<template>
  <div>
    <main id="main" class="shop_mainbox" v-cloak ref="test">
      <section class="loading_area" v-if="!isLoaded">
        <div class="loader"></div>
      </section>

      
      <header>
        <div v-if="groupbuy.isGroupbuy">
          <!-- 揪團一起點bar, 進行ing, 團長可取消/分享, 團員可分享 -->
          <section class="groupbuy_bar flex_center">
            <div class="msg" v-if="!groupbuy.isOnGoing">
              <i class="fas fa-exclamation-circle"></i>
              團員目前無法跟團，請點擊"重啟"開啟跟團
            </div>
            <div class="icon"><i class="fas fa-user-friends"></i></div>
            <div class="status" v-if="groupbuy.isOnGoing">
              一起點進行中<br />
              <div class="master">{{ groupbuy.id }}</div>
            </div>
            <div class="status" v-else>
              一起點已收單<br />
              <div class="master">{{ groupbuy.id }}</div>
            </div>
            <div class="btn flex_center">
              <!-- 已收單狀態, 不顯示分享btn -->
              <a
                v-if="groupbuy.isOnGoing"
                class="share"
                href="#groupbuy"
                rel="modal:open"
                ><i class="fas fa-link"></i> 分享</a
              >
              <a
                v-else
                class="reset"
                href="#"
                @click.prevent="restartGroupbuy()"
                ><i class="fas fa-lock-open"></i> 重啟</a
              >
              <!-- 只有團長能取消揪團 -->
              <a class="cancel" href="#groupbuy_cancel" rel="modal:open"
                ><i class="fas fa-times"></i> 取消</a
              >
            </div>
          </section>

          <!-- 揪團一起點, 取消一起點 -->
          <div
            v-if="groupbuy.isMaster"
            id="groupbuy_cancel"
            class="modal groupbuy"
          >
            <div class="title">
              <i class="fas fa-exclamation-triangle"></i>
              揪團取消後將停止「一起點」，尚未送出訂單的團員將無法送單，確定要繼續嗎?
            </div>
            <div class="sys_btn flex_center">
              <a class="back" href="#" ref="groupbuy_cancel" rel="modal:close"
                >返回</a
              >
              <a class="next" href="#" @click="cancelGroupbuy()">確定取消</a>
            </div>
          </div>
        </div>

        <div class="top_bar line flex_center">
          <div class="shop_name">
            <div class="shop_info" v-cloak>
              <fragment v-if="d.businessEntityName"> {{ d.businessEntityName }}</fragment>
              <fragment v-if="d.businessEntityName &&  d.taxIdNumber">．</fragment>
              <fragment v-if="d.taxIdNumber">統編：{{ d.taxIdNumber }}</fragment>
            </div>
          </div>
        </div>
        <nav class="top_menu flex_center">
          <div class="swiper-container">
            <div id="category-nav" class="swiper-wrapper">
              <!-- 公告 -->
              <div
                v-show="isStoreInfo"
                class="swiper-slide"
                v-on:click="storeInfoClick(0)"
              >
                <p>公告</p>
              </div>

              <!-- 再點一次 -->
              <div
                v-if="businessPubInfo.isRebuild"
                class="swiper-slide"
                v-on:click="selectCategory('ever')"
              >
                <p v-bind:class="{ btn_in: everSwitch && !pickUpLaterSwitch }">
                  再點一次
                </p>
              </div>

              <!-- 寄杯 -->
              <div
                v-if="businessPubInfo.isPickUp"
                class="swiper-slide"
                v-on:click="selectCategory('pick-up-later')"
              >
                <p v-bind:class="{ btn_in: !everSwitch && pickUpLaterSwitch }">
                  寄杯<span v-show="checkTicketQty()" class="nb">{{
                    calTicketQty()
                  }}</span>
                </p>
              </div>

              <!-- products in categories -->
              <div
                class="swiper-slide"
                v-for="category in categories"
                v-on:click="selectCategory(category.categoryId)"
                :key="category.categoryId"
              >
                <p
                  v-bind:class="{ btn_in: categoryBtnIn(category.categoryId) }"
                >
                  {{ category.categoryName
                  }}<span v-show="checkCategoryQty(category)" class="nb">{{
                    calCategoryQty(category)
                  }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="open_menu" @click="openMenuAll()">
            <i class="fas fa-angle-down"></i>
          </div>
        </nav>

        <!-- 打開選單所有分類 -->
        <div class="menu_all">
          <div class="overlay_bg" @click="closeMenuAll()"></div>
          <div class="menu_title">
            <i class="fas fa-bars"></i> 商品分類
            <button class="close" ref="categoryList" @click="closeMenuAll()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="menu_list">
            <a
              v-for="category in categories"
              v-on:click="selectCategoryList(category.categoryId)"
              :key="category.categoryId"
              >{{ category.categoryName
              }}<span v-show="checkCategoryQty(category)" class="nb">{{
                calCategoryQty(category)
              }}</span></a
            >
          </div>
        </div>
      </header>

      <!-- 揪團一起點進行中, 團長可查看已點清單, 未收單連到結帳頁的step1, 已收單連到結帳頁的step2 -->
      <a
        v-if="groupbuy.isGroupbuy && d.isGroupbuy == 'true'"
        class="groupbuy_ordered_list flex_center"
        href=""
        @click.prevent="redirectToOrderFlow()"
        >已點清單</a
      >

      <!-- 揪團一起點開團按鈕, 未開團或未加入開團時才顯示 -->
      <a
        v-else-if="!groupbuy.isGroupbuy && d.isGroupbuy == 'true'"
        class="groupbuy_startbtn flex_center"
        href="#groupbuy_create"
        rel="modal:open"
        ><i class="fas fa-user-friends"></i>揪團</a
      >
      <div id="groupbuy_create" class="modal groupbuy">
        <div class="title">
          <i class="fas fa-exclamation-triangle"></i>
          您即將開啟「一起點」團訂功能，將點餐連結分享給好友們吧！
        </div>
        <div class="sys_btn flex_center">
          <a
            class="back"
            href="#groupbuy_create"
            ref="groupbuy_create_cancel"
            rel="modal:close"
            >返回</a
          >
          <a
            class="share"
            href="#groupbuy"
            ref="groupbuy_share"
            rel="modal:open"
            style="display: none;"
            ><i class="fas fa-link"></i> 分享</a
          >
          <a class="next" href="#" @click="createGroupbuy()">確定</a>
        </div>
      </div>

      <!-- 揪團一起點, 分享連結 -->
      <div id="groupbuy" class="modal groupbuy">
        <div class="title">
          分享連結 ლ(╹◡╹ლ)<br />好東西就是要跟好友一起分享！
        </div>
        <div class="copy_link">
          <input type="text" name="" :value="lineShareUrl" disabled />
          <!-- <button class="btn_yello" type="button">複製連結</button> -->
          <button class="" type="button">
            <a :href="lineShareUrl">LINE分享</a>
          </button>
        </div>
        <div class="qrcode_img">
          <qrcode
            :value="groupbuy.shareableUrl"
            :options="{ width: 190 }"
          ></qrcode>
        </div>
      </div>

      <!-- cart icon -->
      <div class="icon_cart">
        <a
          href="#shopping_cart"
          rel="modal:open"
          ref="shopping_cart"
          v-show="businessPubInfo.isEnabled"
        >
          <span class="nb">{{
            countTotal().totalQty
          }}</span>
          <i class="fas fa-shopping-cart"></i>
        </a>
      </div>

      <section class="order_tools">
        <div class="container flex_center" v-if="businessPubInfo.isEnabled">
          <div class="order_amount">
            訂單小計<span
              >$<b>{{ countTotal().totalAmount.toFixed(2).replace(/[.,]00$/, "") }}</b></span
            >
            <div class="kcal" v-if="countTotal().totalCalorie && isCalorie">
              總卡路里：{{ countTotal().totalCalorie }}kcal
            </div>
          </div>
          <a
            class="btn next"
            v-on:click.prevent="checkCart(toPay)"
            target="_self"
            >確認訂單</a
          >
        </div>

        <!-- 暫停開放點餐時顯示 -->
        <div class="container flex_center" v-else>
          <a class="btn disable">暫不開放點餐</a>
        </div>

        <!-- <button v-on:click="$emit('update:user-login')">
          emit test
        </button> -->
      </section>

      <main class="product_area" ref="p">
        <div class="container">
          <div class="searchbar">
            <div class="container flex_center">
              <button type="button"><i class="fas fa-search"></i></button>
              <input
                type="text"
                placeholder="搜尋全部商品"
                v-model="searchStr"
              />
            </div>
          </div>

          <h1>{{ selectedCategoryName }}</h1>

          <!-- product list -->
          <ul
            class="product_list"
            :class="{ style_one: isStyleOne }"
            v-if="!everSwitch && !pickUpLaterSwitch"
          >
            <li
              class="flex_top"
              v-bind:class="product.class"
              v-for="product in products"
              v-on:click="chooseProduct(product)"
              v-show="product.isShow"
              :key="product.productId"
            >
              <div
                class="product_info"
                :class="{ with_photo: product.productImage }"
              >
                <div class="name">{{ product.productName }}<i class="tag" v-for="(tag, index) in product.tags" :key="'p-info-tag' + index">{{tag.text}}</i></div>
                <div
                  v-if="product.productDescription"
                  class="desc"
                  v-html="product.productDescription"
                ></div>
                <div class="price">
                  $<b>{{ product.productAmount }}</b>
                  <del v-show="product.pricing">${{ product.pricing }}</del>
                </div>
                <div class="kcal" v-if="product.calorie && isCalorie">
                  卡路里：{{ product.calorie }}kcal
                </div>
                <div v-if="checkIfProductRemain(product)" class="inventory">
                  剩餘數量：{{ product.numOfRemain }}
                </div>
              </div>
              <div
                v-if="product.productImage"
                class="photo"
                :style="setProductImage(product.productImage)"
              ></div>
              <div v-show="product.qty > 0" class="nb">{{ product.qty }}</div>
              <div v-if="checkIfSoldOut(product)" class="sold_out flex_center">
                <b>售完</b>
              </div>
            </li>
          </ul>
          <!-- END .product_list -->

          <!-- rebuild list -->
          <ul class="ordered_list" v-else-if="everSwitch">
            <li v-for="(order, index) in everOrders" :key="index">
              <div class="order_info">
                訂單編號：{{ order.orderId }}<br />下單時間：{{
                  order.createdAt
                }}
              </div>
              <ul
                class="products"
                v-for="product in order.products"
                :key="product.productId"
              >
                <li>{{ product.qty }} x {{ product.name }}</li>
              </ul>
              <div class="focus">
                <!-- <div class="price">$<b>60</b></div> -->
                <button class="addtocart" @click="rebuidCart(order.orderId)">
                  加入購物車
                </button>
              </div>
            </li>
          </ul>
          <!-- END rebuild list -->

          <!-- 寄杯 list -->
          <ul class="product_list pickup_next" v-else-if="pickUpLaterSwitch">
            <li
              class="flex_top"
              v-for="(ticket, index) in pickUpTickets"
              @click="choosePickUp(ticket)"
              :key="index"
            >
              <div class="product_info with_photo">
                <div class="name">{{ ticket.productName }}</div>
                <div class="bought_num">
                  購買數量：{{ ticket.ticket ? ticket.ticket.buyQty : '' }}
                </div>
                <div class="remaining">
                  剩餘次數：{{ ticket.ticket ? ticket.ticket.availableQty : '' }}
                </div>
                <time :class="{overtime: ticket.ticketStatus == 'expired'}"
                  >使用期限：{{ ticket.ticket ? ticket.ticket.usingEndDate.slice(0, 10) : '' }}</time
                >
              </div>
              <div
                class="photo"
                :style="setProductImage(ticket.productImage)"
              ></div>
              <!-- <div v-show="displayTicketList(ticket).qty > 0" class="nb">{{ displayTicketList(ticket).qty }}</div> -->
            </li>
          </ul>
          <!-- END 寄杯 list -->
        </div>
        <!-- END .container -->
      </main>
      <!-- END .product_area -->

      <!-- 購物車 -->
      <div id="shopping_cart" class="modal shopping_cart">
        <div class="title">訂購明細</div>
        <div class="title_s">
          目前選購 <b>{{ countTotal().totalQty }}</b> 項商品
        </div>
        <ul class="shopping_car_list">
          <!-- cart products -->
          <li
            class="flex_top"
            v-for="(cartProduct, index) in cartProducts"
            :key="index"
          >
            <div class="product_info">
              <div class="name">{{ cartProduct.productName }}</div>
              <div class="desc" v-html="cartProduct.productDescription"></div>
              <div v-if="cartProduct.addonStr" class="other">
                {{ cartProduct.addonStr }}
              </div>
              <div class="money">
                ${{ displayOriginSingleAmountInCart(cartProduct) }}
                {{ displaySignOfSingleProductAddonInCart(cartProduct) }} ${{displaySingleProductAddonAmountInCart(cartProduct)}}
                =
                {{displaySignOfSingleProductAmountWithAddonAmountInCart(cartProduct)}}${{displaySingleProductAmountWithAddonAmountInCart(cartProduct)}}
              </div>
            </div>
            <div
              v-if="cartProduct.productImage"
              class="photo"
              :style="setProductImage(cartProduct.productImage)"
            ></div>
            <div class="set_num flex_center">
              <div class="input_quantity flex_center">
                <button
                  :disabled="isDisabled"
                  v-on:click="cartProductMinus(cartProduct, index)"
                >
                  <i class="fas fa-minus"></i>
                </button>
                <input
                  type="number"
                  v-model="cartProduct.qty"
                  placeholder="0"
                  @change="cartProductNumChange(cartProduct)"
                />
                <button
                  :disabled="isDisabled"
                  v-on:click="cartProductPlus(cartProduct)"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
              <div class="money">
                <!-- {{cartProduct.qty}} x {{cartProduct.productAmount + cartProduct.addonAmt < 0 ? '-' : ''}}${{Math.abs(cartProduct.productAmount + cartProduct.addonAmt)}} = {{cartProduct.productAmount + cartProduct.addonAmt < 0 ? '-' : ''}}${{Math.abs((cartProduct.productAmount + cartProduct.addonAmt) * cartProduct.qty)}} -->
                {{displaySignOfSingleProductAmountWithAddonAmountInCart(cartProduct)}}$<b>{{
                  displaySingleSameProductAmountInCartSubtotal(cartProduct)
                }}</b>
                <div
                  class="kcal"
                  v-if="checkIfDisplayCalorieWithCartProduct()"
                >
                  {{ displaySingleSameProductsWithAddonsCalorieInCartSubtotal(cartProduct) }}kcal
                </div>
              </div>
            </div>
          </li>

          <!-- cart tickets -->
          <li
            class="flex_top"
            v-for="(cartTicket, index) in cartTickets"
            :key="'ct' + index"
          >
            <div class="product_info">
              <div class="name">{{ cartTicket.productName }}</div>
              <div class="desc" v-html="cartTicket.productDescription"></div>
              <div v-if="cartTicket.addonStr" class="other">
                {{ cartTicket.addonStr }}
              </div>
              <div class="money">
                $0
                {{displaySignOfSingleTicketAmountInCart(cartTicket)}} ${{
                  displayOriginSingleTicketAddonAmountInCart(cartTicket)
                }}
                =
                {{displaySignOfSingleTicketAmountInCart(cartTicket)}}${{
                  displayOriginSingleTicketAmountInCart(cartTicket)
                }}
              </div>
              <div class="pickup_next">寄杯憑證</div>
            </div>
            <div
              v-if="cartTicket.productImage"
              class="photo"
              :style="setProductImage(cartTicket.productImage)"
            ></div>
            <div class="set_num flex_center">
              <div class="input_quantity flex_center">
                <button
                  :disabled="isDisabled"
                  v-on:click="cartTicketMinus(cartTicket, index)"
                >
                  <i class="fas fa-minus"></i>
                </button>
                <input
                  type="number"
                  v-model="cartTicket.qty"
                  placeholder="0"
                  @change="cartTicketNumChange(cartTicket, index)"
                />
                <button
                  :disabled="isDisabled"
                  v-on:click="cartTicketPlus(cartTicket)"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
              <div class="money">
                {{displaySignOfTicketsAmountInCartSubtotal(cartTicket)}}$<b>{{displaySingleSameTicketsAmountInCartSubtotal(cartTicket)}}</b>
                <div
                  class="kcal"
                  v-if="checkIfDisplayCalorieWithCartTicket()"
                >
                  {{ displaySingleSameTicketsWithAddonsCalorieInCartSubtotal(cartTicket) }}kcal
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="totalbar">
          總計 <b>{{ countTotal().totalQty }}</b> 項 / 共
          <span class="price"
            >$<b>{{ countTotal().totalAmount.toFixed(2).replace(/[.,]00$/, "") }}</b></span
          >
          <div class="kcal" v-if="countTotal().totalCalorie && isCalorie">
            總卡路里：{{ countTotal().totalCalorie }}kcal
          </div>
        </div>

        <div class="sys_btn flex_center">
          <a class="back" href="#" rel="modal:close" ref="contiShopping"
            >回目錄</a
          >
          <a class="next" v-on:click.prevent="checkCart(toPay)" target="_self"
            >確認訂單</a
          >
        </div>
      </div>

      <!-- 請選擇寄杯 -->
      <div id="pickup_next" class="modal food_items">
        <div
          class="photo"
          :style="setProductImage(selectedTicket.productImage)"
        ></div>

        <h2 class="product_name">{{ selectedTicket.productName }}
          <i class="tag" v-for="(tag, index) in selectedTicket.tags" :key="'p-name-tag' + index">{{tag.text}}</i>
          <div class="price">
            <del>$<b>{{ selectedTicket.productAmount }}</b></del>
            <del v-show="selectedTicket.pricing"
              >${{ selectedTicket.pricing }}</del
            >
          </div>
        </h2>
        <div class="kcal" v-if="selectedTicket.calorie && isCalorie">
            卡路里：{{ selectedTicket.calorie }}kcal
          </div>

        <div class="product_info editor">
          <div class="bought_num">
            購買數量：{{ selectedTicket.ticket.buyQty }}
          </div>
          <div class="remaining">
            剩餘次數：{{ selectedTicket.ticket.availableQty }}
          </div>
          <time
            >使用期限：{{
              selectedTicket.ticket.usingEndDate.slice(0, 10)
            }}</time
          >
        </div>

        <div v-for="(option, index) in ticketOptions" :key="'ticket-'+index">
          <div v-if="option.type == 'radio'">
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>
            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="'ticket-'+index">
                <div v-if="item.isVisibled" class="the_radio">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+index"
                    @click="ticketOptionRadioCheck($event, item.id, item.subItems)"
                  />
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
                <div v-else class="the_radio out_of_stock">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+index"
                    @click="ticketOptionRadioCheck($event, item.id, item.subItems)"
                    disabled
                  />
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>
            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="'ticket-'+index">
                <div v-if="item.isVisibled" class="the_checkbox">
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+index"
                    @click="ticketOptionCheckboxCheck($event, item.id, item.subItems)"
                  />
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
                <div v-else class="the_checkbox out_of_stock">
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+index"
                    @click="ticketOptionCheckboxCheck($event, item.id, item.subItems)"
                    disabled
                  />
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="input_quantity flex_center">
          <button @click="adjustSelectedTicketQty('minus')">
            <i class="fas fa-minus"></i>
          </button>
          <input type="number" min="1" v-model="selectedTicketQty" />
          <button @click="adjustSelectedTicketQty('plus')">
            <i class="fas fa-plus"></i>
          </button>
        </div>

        <div class="sys_btn flex_center">
          <a class="back" href="#" rel="modal:close">回目錄</a>
          <a class="next" @click="chooseTicketConfirm()">選好了</a>
        </div>
      </div>

      <!-- 請選擇 品項 與 加購-->
      <div id="food_items" class="modal food_items">
        <div
          v-if="selectedProduct.productImage"
          class="photo"
          :style="setProductImage(selectedProduct.productImage)"
        ></div>
        <h2 class="product_name">
          {{ selectedProduct.productName }}
          <i class="tag" v-for="(tag, index) in selectedProduct.tags" :key="'p-name-tag' + index">{{tag.text}}</i>
          <div class="price">
            $<b>{{ selectedProduct.productAmount }}</b>
            <del v-show="selectedProduct.pricing"
              >${{ selectedProduct.pricing }}</del
            >
          </div>
          <div class="kcal" v-if="selectedProduct.calorie && isCalorie">
            卡路里：{{ selectedProduct.calorie }}kcal
          </div>
        </h2>
        <div
          v-if="selectedProduct.productDescription"
          class="product_info editor"
          v-html="selectedProduct.productDescription"
        ></div>

        <div v-for="(option, index) in options" :key="index">
          <div v-if="option.type == 'radio'">
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>
            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="index">
                <div v-if="item.isVisibled" class="the_radio">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="index"
                    @click="optionRadioCheck($event, item.id, item.subItems)"
                  />
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
                <div v-else class="the_radio out_of_stock">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="index"
                    @click="optionRadioCheck($event, item.id, item.subItems)"
                    disabled
                  />
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>
            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="index">
                <div v-if="item.isVisibled" class="the_checkbox" :class="{choice_num: isMultiCheckbox(item, option)}">
                  <button v-if="isMultiCheckbox(item, option) && businessPubInfo.isMinusButton" :class="{set_reset: isMultiCheckbox(item, option), display: item.qty > 0 && isMultiCheckbox(item, option)}" :key="'set_reset'+item.id" @click.prevent="minusMultiCheckbox(item, option)">—</button>
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="index"
                    @click="optionCheckboxCheck($event, item.id, item.subItems, item, option)"
                  />
                  <label
                    :class="{multi_checkbox_checked: item.qty > 0, multi_checkbox: (item.qty === 0 || item.qty === undefined) && isMultiCheckbox(item, option)}"
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    :class="{multi_checkbox_checked: item.qty > 0, multi_checkbox: (item.qty === 0 || item.qty === undefined) && isMultiCheckbox(item, option)}"
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label 
                    :class="{multi_checkbox_checked: item.qty > 0, multi_checkbox: (item.qty === 0 || item.qty === undefined) && isMultiCheckbox(item, option)}"
                    v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label 
                    :class="{multi_checkbox_checked: item.qty > 0, multi_checkbox: (item.qty === 0 || item.qty === undefined) && isMultiCheckbox(item, option)}"
                    v-else :for="item.id"
                    >{{ item.label }}</label>
                  <div class="set_num" :key="'set_num'+item.id" :style="item.style">{{item.qty}}</div>
                </div>
                <div v-else class="the_checkbox out_of_stock">
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="index"
                    @click="optionCheckboxCheck($event, item.id, item.subItems)"
                    disabled
                  />
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
              <li class="reset_bar">
                <button class="reset_all_num" v-show="showResetAllNum(option.values)" @click="resetSetNum(option.values, option)">重設加購數量</button>
              </li>
            </ul>
          </div>
        </div>
        <div class="input_quantity flex_center">
          <button @click="adjustSelectedProductQty('minus')">
            <i class="fas fa-minus"></i>
          </button>
          <input type="number" v-model="selectedProductQty" placeholder="0" />
          <button @click="adjustSelectedProductQty('plus')">
            <i class="fas fa-plus"></i>
          </button>
        </div>

        <div class="sys_btn flex_center">
          <a class="back" href="#" rel="modal:close">回目錄</a>
          <a class="next" @click="optionConfirm()">選好了</a>
        </div>
      </div>

      <!-- 飲料-->
      <div id="food_items2" class="modal food_items">
        <div v-for="(option, index) in subOptions" :key="index">
          <div v-if="option.type == 'radio'">
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>

            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="index">
                <div v-if="item.isVisibled" class="the_radio">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="createSubOptionKey(item.id)"
                    @click="subOptionRadioCheck($event)"
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
                <div v-else class="the_radio out_of_stock">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="createSubOptionKey(item.id)"
                    @click="subOptionRadioCheck($event)"
                    disabled
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="option.type == 'selectboxes'">
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>

            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="index">
                <div v-if="item.isVisibled" class="the_checkbox">
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="createSubOptionKey(item.id)"
                    @click="subOptionCheckboxCheck($event)"
                    :checked="false"
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
                <div v-else class="the_checkbox out_of_stock">
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="createSubOptionKey(item.id)"
                    @click="subOptionCheckboxCheck($event)"
                    :checked="false"
                    disabled
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="sys_btn flex_center">
          <a class="next" @click="subOptionConfirm()">選好了</a>
        </div>
      </div>

      <!-- 寄杯加購2 -->
      <div id="ticket_items2" class="modal food_items">
        <div v-for="(option, index) in ticketSubOptions" :key="'ticket-'+index">
          <div v-if="option.type == 'radio'">
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>

            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="'ticket-'+index">
                <div v-if="item.isVisibled" class="the_radio">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+createSubOptionKey(item.id)"
                    @click="ticketSubOptionRadioCheck($event)"
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
                <div v-else class="the_radio out_of_stock">
                  <input
                    type="radio"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+createSubOptionKey(item.id)"
                    @click="ticketSubOptionRadioCheck($event)"
                    disabled
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="option.type == 'selectboxes'">
            <div class="title">
              <span class="must" v-show="option.required">*必選</span
              >{{ option.label }}<i class="fas fa-caret-down"></i>
            </div>
            <div class="title_s">{{ option.description }}</div>

            <ul class="option_list">
              <li v-for="(item, index) in option.values" :key="'ticket-'+index">
                <div v-if="item.isVisibled" class="the_checkbox">
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+createSubOptionKey(item.id)"
                    @click="ticketSubOptionCheckboxCheck($event)"
                    :checked="false"
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
                <div v-else class="the_checkbox out_of_stock">
                  <input
                    type="checkbox"
                    :name="option.id"
                    :id="item.id"
                    :value="item.id"
                    :key="'ticket-'+createSubOptionKey(item.id)"
                    @click="ticketSubOptionCheckboxCheck($event)"
                    :checked="false"
                    disabled
                  />
                  <!-- add calories -->
                  <label
                    v-if="item.price && item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}({{ item.calorie }}kcal)</label
                  >
                  <label
                    v-else-if="item.calorie && isCalorie"
                    :for="item.id"
                    >{{ item.label }}({{ item.calorie }}kcal)</label
                  >
                  <label v-else-if="item.price" :for="item.id"
                    >{{ item.label }}{{ item.price &lt; 0 ? "-" : "+" }}${{
                      Math.abs(item.price)
                    }}</label
                  >
                  <label v-else :for="item.id">{{ item.label }}</label>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="sys_btn flex_center">
          <a class="next" @click="ticketSubOptionConfirm()">選好了</a>
        </div>
      </div>

      <!-- 公告 -->
      <div id="store_notice" class="modal store_notice">
        <div class="title">公告</div>
        <article class="notice_content">
          <div class="photo_content">
            <img
              v-if="businessPubInfo.imageUrl"
              :src="businessPubInfo.imageUrl"
              width="100%"
            />
          </div>
          <div class="ql-editor" ref="result" id="result"></div>
          <pre v-if="!isQlEditor && isReadyToShowInfo" class="ql-editor">{{
            businessPubInfo.content
          }}</pre>
        </article>
        <div class="sys_btn flex_center">
          <a
            class="next"
            href="#store_notice"
            rel="modal:close"
            @click="storeInfoClicked()"
            >確定</a
          >
        </div>
      </div>
      <a ref="food_items" href="#food_items" rel="modal:open"></a>
      <a ref="pick_up" href="#pickup_next" rel="modal:open"></a>
      <a ref="food_items2" href="#food_items2" rel="modal:open"></a>
      <a ref="ticket_items2" href="#ticket_items2" rel="modal:open"></a>
      <a ref="store_notice" href="#store_notice" rel="modal:open"></a>

      <!-- 選單滑動提示 -->
      <section class="changeMenu_demo" v-show="!isReadTutorial && isLoaded">
        <div class="inner">
          <div class="teach">
            <div>左滑<b>可快速切換</b>商品分類</div>
            <div class="arrow"></div>
            <div class="finger"></div>
          </div>
          <div class="argree_term">
            點選我知道了，即代表您同意<br /><a @click="agreePolicy()"
              >「網站服務條款及隱私權政策」</a
            >
          </div>
          <button class="btn" @click="clickMenuHint()">我知道了</button>
        </div>
      </section>

      <!-- 隱私權政策及服務條款 -->
      <div id="privacy_term" v-show="!isReadTutorial && isLoaded">
        <a class="close"><i class="fas fa-times"></i></a>
        <div class="btn_select">
          <!-- 關掉隱私權 及 選單滑動提示 -->
          <button class="btn" @click="clickMenuHint()">
            我知道了
          </button>
        </div>
        <div class="container">
          <h3>個人資料授權原則及使用同意書</h3>
          <p>
            【{{ d.company }}】(以下稱「本公司」)提供之「{{ d.service }}
            」（以下稱「本服務」）非常重視並尊重您的隱私權。為了幫助您瞭解本服務如何收集、應用及保護您的個人資訊，請詳細閱讀以下個人資料授權原則及使用同意書(以下稱「本同意書」)。由於本公司必須收集以下個人資料及使用同意，才能確保服務持續性並保障您的權益，因此若您不同意以下本同意書之全部或部分內容，請您停止使用本服務。為尊重您的選擇，您有權隨時撤回對本同意書之同意。
          </p>
          <ol>
            <li>
              1.本同意書之範圍：本同意書適用於您使用本服務或向本服務透過電話、傳真、電子郵件或其他傳輸方式提出查詢、點餐或行銷活動時，所涉及之個人資料蒐集、處理與利用行為。您瞭解並同意，若您使用本服務時有點擊或瀏覽本公司或本服務以外之第三方連結或網站，您的個人資料將適用該第三方之個人資料保護政策，本同意書並不適用。
            </li>
            <li>
              2.個人資料蒐集之目的:提供您使用本服務，並協助本公司運營所必要之一切目的，包含但不限於本服務之運作、行銷、廣告、會員管理、數據統計、優化、第三人之業務合作、驗證您的身分、協助執法機關及政府機關執行公務。
            </li>
            <li>
              3.個人資料蒐集類型：本公司可能會蒐集到包含但不限於您的姓名、出生年月日、國民身分證統一編號、護照號碼、特徵、指紋、婚姻、家庭、教育、職業、聯絡方式、財務情況、社會活動及其他與本服務相關而得以直接或間接方式識別您之個人資料（包含但不限於LINE
              User ID、信用卡資訊、IP地址、憑證序號、銀行帳戶等）。
            </li>
            <li>
              4.適當安全維護措施：依「個人資料保護法施行細則」（下稱「個資法施行細則」）第12條，適當安全維護措施指廠商為防止個人資料被竊取、竄改、毀損、滅失或洩漏，採取技術上及組織上之措施；前述措施得包括配置管理之人員及相當資源、界定個人資料之範圍、個人資料之風險評估及管理機制、事故
              之預防、
              通報及應變機制、個人資料蒐集、處理及利用之內部管理程序、資料安全管理及人員管理、認知宣導及教育訓練、設備安全管理、資料安全稽核機制、使用
              紀錄
              、軌跡資料及證據保存及個人資料安全維護之整體持續改善。本公司將依此提供符合相關法令規定之技術與安全維護措施，以妥善保護您的個人資料。
            </li>
            <li>
              5.個人資料利用之期間：自您開始 使用本服務時，至您要
              求停止使用本服務之時，或本公司停止向您提供本服務為止（以時間較早者為準）。
            </li>
            <li>
              6.個人資料利用之地區：同意將您的個人資料利用於本公司執行業務、運營本服務及伺服器存放之地區。
            </li>
            <li>
              7.個人資料之分享:除以下任一情況外，本公司不會將您的個人資料提供於本公司以外之第三人：(1)於事先取得您同意之情形下；(2)本公司得將個人資訊提供給本公司之海內外關係企業、合作夥伴(例如:提供餐點之商家或LINE)、委外或協力廠商(例如:行銷公司、廣告公司、系統維護公司、系統服務供應商、系統建置
              公司、數據分析公司)、經本公司合法授權之第三方、以及本服務信任之第三方或人員；(3)須提供您的個人資料予第三人，始能提供你所要求之服務；(4)政府機
              構或執法機關，或本公司基於法律上之原因而須提供。本公司會確保上述第三方於處理過程中遵從本服務之指示及本同意書與相關法令之規範。
            </li>
            <li>
              8.個人資料之自主權:您可向本公司申請就您提供的資料，依中華民國個人資料保護法之規定行使權利，如：(1)查詢或請求閱覽、(2)請求製給複製本、(3)請求補充或更正
              、(4)請求停止蒐集、處理、利用或(5)請求刪除，然本公司得向您酌收處理費用以先行查證您是否為個人資料所有人，並要求您提供相關個人資料以協助查證及處理程序。倘您的要求將對國家重大利益、公務機關執行法定職務、蒐集機關或第三人之重大利益有妨害時，本公司有權拒絕您的申請。
            </li>
            <li>
              9.您瞭解並同意不使用本服務提供之LINE官方帳號作為任何第三人之廣告媒體（包含但不限於透過使用LINE官方帳號宣傳第三人之商品或服務）。
            </li>
            <li>
              10.您瞭解並同意本公司會向您提供由本公司提供者(LINE
              Provider)建立的通道（LINEChannel）綁定由本公司建立的LINE官方帳號並依您指定的名稱命名LINE官方帳號。
            </li>
            <li>
              11.未經本服務事前同意，不得要求或自行轉換提供者(LINE
              Provider)；若違反此條款，本公司有權暫停或終止相關官方帳號之使用。若您事前向本公司告知且本公司同意，您必須
              自行申請LINE官方帳號服務，並建立您專屬的LINE提供者(Provider)，再交由本公司整合使用，其整合費用及顧問費用由本公司另行報價，您亦瞭解此過程需承擔數據資料服務延續性之中斷或遺失等風險，本公司不就因此所生之損害對客戶負擔任何責任。
            </li>
            <li>
              12.若您有使用LINE或其他社群服務，本公司及海內外關係企業可能於您使用本服務時，向您詢問是否將本服務之資訊發布於您的社群頁面，若您不同意請勿點選同意鍵，然為尊重您的決定，您亦得隨時向本公司撤回該同意並於您的社群頁面上移除該等資訊。
            </li>
            <li>
              13.您應確保所提供之個人資料係合法真實且完整正確，若您提供之個人資料有虛偽、錯誤、違反法令或侵害第三人權利，可能導致您無法使用本服務，本公司並有權終止對您的服務。倘您提供之個人資料因違反上述情形，而致第三人受有損害或受執法機關追訴責任，您瞭解並同意本公司不負擔任何責任。
            </li>
            <li>
              14.若您不願意提供，或要求本公司停止蒐集、處理、利用或刪除您的個人資料，本公司將尊重您的決定，但您可能因此無法使用本服務或完成相關交易，本公司並保留是否同意終止對您的服務或完成相關交易之權利。
            </li>
            <li>
              15.倘未成年人於使用本服務有同意本公司蒐集、利用及處理其個人資訊時，應在法定代理人或監護人之同意下為之。其法定代理人或監護人得隨時請求本公司終止該帳號之服務，或請求本同意書第6條個人資料自主權之行為。
            </li>
            <li>
              16.無論明示或暗示，本公司不保證LINE官方帳號或本服務含有之第三方連結及網站不存在事實上或法律上之瑕疵（包含但不限於與安全性、可靠性、正確性、完整性、有效性、針對特
              定目的之適用性、安全等相關之缺陷
              、錯誤、漏洞、權利侵害等），您瞭解並同意本公司不就第三方對您引起的任何損害負擔責任。
            </li>
            <li>
              17.您瞭解此個人資料授權原則及使用同意書符合個人資料保護法及相關法規之要求，且瞭解其內容，並同意本同意書所列之事項。本同意書如有未盡事宜，本服務將依中華民國個人資料保護法或其他相關法規及其後修訂之規定辦理。本公司將不定時修訂本同意書，該修訂之最新版本將於發布時即當然生效。若您不同意修訂之內容，請停止使用本服務，並依本同意書之規定通知本公司停止蒐集、處理、利用或刪除您的個人資料。若您於該等修訂後，仍有繼續使用本服務之情事，則視為您同意受最新修訂之同意書內容所拘束。
            </li>
            <li>
              18.您瞭解網際網路非百分之百安全的環境，並可能存在事實上或法律上之瑕疵（包含但不限於與安全性、可靠性、正確性、完整性、有效性、針對特定目的之適用性、安全等相關之缺陷、錯誤、漏洞、權利侵害等），你同意對個人資料及使用本服務的資訊善盡保管義務，對使用本服務的伺服器及裝置安裝防毒軟體或相關防護裝置，以避免外洩或遭第三人取用，您須自行對未善盡保管義務所引起之損害負擔責任，您同時瞭解並同意自行承擔網際網路之環境風險及。
            </li>
            <li>
              19.Cookies之使用:Cookies是一種小型檔案，於您使用本服務時會儲存某些資訊在您的使用裝置(例如:電腦、平板、手機)中。您瞭解並同意本公司使用Cookies以利本公司分析、蒐集、保存您的使用模式、喜好，以增進您使用本服務之體驗、維持本服務之運作、改善本服務之效能、投放適合您的廣告及為維持本公司營運之相關目的。為尊重您的決定，您仍可以於您的裝置瀏覽器中取消或限制此功能。然當您選擇限制或取消Cookies時，可能導致您無法使用本服務之一部或全部之內容。
            </li>
            <li>20.若您對本同意書所列事項有疑問，請聯絡本公司。</li>
            <li>
              21.本同意書之解釋、履行及效力悉依中華民國法律為準據法，並以台灣台北地方法院為第一審管轄法院。
            </li>
          </ol>
          <p>
            本人
            已詳閱本服務依個人資料保護法所告知事項並清楚瞭解蒐集、處理或利用個人資料之目的及使用同意之授權。
          </p>
          <br />
          <br />
          <div v-html="shopPrivacy"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import $ from "jquery";
import "jquery-modal";
import Swiper from "swiper";
import VueQrcode from "@chenfengyuan/vue-qrcode";

import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "swiper/swiper-bundle.css";

export default {
  name: "App",
  components: {
    qrcode: VueQrcode
  },
  props: {
    d: {
      type: Object,
      required: true,
      default() {
        return {
          flowType: "liff",
          liffAccessToken: "",
          apiDomain: "http://localhost:7654/line",
          accountId: 1,
          liffId: "1654329347-Vkd7bKDq",
          source: "qc",
          token:
            "6ff65bbb3e5fc9b36fc2ebb9ecfed4dced55490226bf451528bdea5130d1eea8",
          company: "",
          service: "",
          isGroupbuy: "true",
          profile: {
            userLineId: "U1bc352e7934d3df724edfbbcf05d594c",
            displayName: "ken",
            pictureUrl: null
          },
          businessEntityName: 'Business name',
          taxIdNumber: 'Tax ID'
        };
      }
    }
    // source: {
    //   type: String,
    //   required: true
    // },
    // token: {
    //   type: String,
    //   required: true
    // },
    // apiDomain: {
    //   type: String,
    //   required: true
    // },
    // accountId: {
    //   type: Number,
    //   required: true
    // },
    // isGroupbuy: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      // d: {
      //   flowType: "liff",
      //   liffAccessToken: "",
      //   apiDomain: "http://localhost:7654/line",
      //   accountId: 1,
      //   liffId: "1654329347-Vkd7bKDq",
      //   source: "qc",
      //   token:
      //     "6ff65bbb3e5fc9b36fc2ebb9ecfed4dced55490226bf451528bdea5130d1eea8",
      //   company: "",
      //   service: "",
      //   isGroupbuy: "true",
      //   profile: {
      //     userLineId: "U1bc352e7934d3df724edfbbcf05d594c",
      //     displayName: "ken",
      //     pictureUrl: null
      //   }
      // },
      // accountId: 1,
      // source: "<%= source %>",
      // token: "${this.d.token}",
      // apiDomain: "http://localhost:7654/line",
      // isGroupbuy: "true",
      pickUpTickets: [],
      selectedTicket: {
        ticket: {
          usingEndDate: ""
        }
      },
      selectedTicketQty: 1,
      cartTickets: [],
      lineShareUrl: "",
      groupbuy: {
        id: null,
        isOnGoing: false,
        isConfirmed: false,
        isCancelled: false,
        isGroupbuy: false
      },
      shopPrivacy: null,
      isCalorie: false,
      everOrders: [],
      everSwitch: false,
      pickUpLaterSwitch: false,
      isReadyToShowInfo: false,
      categories: [],
      products: [],
      productsBk: [],
      cartProducts: [],
      selectedCategoryId: "",
      selectedCategoryName: "",
      selectedProducts: [],
      displayCartProducts: [],
      userId: "",
      isDisabled: false,
      toPay: "",
      options: [],
      ticketOptions: [],
      subOptions: [],
      ticketSubOptions: [],
      cartOptions: [],
      ticketCartOptions: [],
      cartSubOptions: [],
      ticketCartSubOptions: [],
      selectedProduct: {},
      selectedProductId: "",
      selectedOptionId: "",
      selectedItemId: "",
      selectedProductQty: 1,
      businessPubInfo: {
        isRead: 1,
        imageUrl: "",
        content: "",
        isRebuild: true,
        isPickUp: false
      },
      isStoreInfo: false,
      isLoaded: false,
      isStyleOne: true,
      isQlEditor: false,
      isReadTutorial: true,
      searchStr: "",
      touchObj: {
        startTime: "",
        endTime: "",
        touches: {},
        ismoved: !1
      }
    };
  },
  created: function() {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  mounted: function() {
    let TouchEvents = [
      "tap",
      "longtap",
      "swipeup",
      "swipedown",
      "swipeleft",
      "swiperight",
      "swipe",
      "drag"
    ];
    //register the touch event
    TouchEvents = TouchEvents.map((evt) => {
      return {
        name: evt,
        evt: new Event(evt)
      };
    });
    let pD = !1,
      _dg = !1;
    let that = this;
    this.$nextTick(() => {
      document.addEventListener(
        "touchstart",
        (e) => {
          e.stopPropagation();
          pD && e.preventDefault();
          that.touchObj.startTime = new Date().getTime();
          that.touchObj.touches.start = e.changedTouches[0];
        },
        false
      );
      document.addEventListener(
        "touchmove",
        (e) => {
          e.stopPropagation();
          that.touchObj.touches.move = e.changedTouches[0];
          this.moveCheck(_dg, document);
        },
        false
      );

      document.addEventListener(
        "touchend",
        (e) => {
          e.stopPropagation();
          that.touchObj.endTime = new Date().getTime();
          that.touchObj.touches.end = e.changedTouches[0];
          let n = _dg
            ? 7
            : this.typeCheck(that.touchObj.endTime - that.touchObj.startTime);
          // 4: left, 5: right
          $(function() {
            var mySwiper;
            if (n == 4) {
              // top 菜單
              $(".swiper-slide p.btn_in")
                .parent()
                .next()
                .find("p")
                .parent()
                .click();
              mySwiper = $(".swiper-container")[0].swiper;
              mySwiper.slideNext();
            } else if (n == 5) {
              $(".swiper-slide p.btn_in")
                .parent()
                .prev()
                .find("p")
                .parent()
                .click();
              mySwiper = document.querySelector(".swiper-container").swiper;
              mySwiper.slidePrev();
            }
          });
          document.dispatchEvent(TouchEvents[n].evt);
          that.touchObj.ismoved = !1;
        },
        false
      );
    });

    let config = {
      method: "post",
      url: `${this.d.apiDomain}/system/users`,
      data: {
        profile: this.d.profile,
        accountId: this.d.accountId
      }
    };
    axios(config).then((response) => {
      this.userId = response.data.userId;
      this.isReadTutorial = response.data.isReadTutorial ? true : false;
      this.toPay = `${this.d.apiDomain}/views/liff/liff2-order-flow?accountId=${this.d.accountId}&userId=${this.userId}&liffId=${this.d.liffId}&source=${this.d.source}&token=${this.d.token}`;
      // get pick-up tickets
      axios
        .get(`${this.d.apiDomain}/system/accounts/${this.d.accountId}/pick-up/tickets?userId=${this.userId}`)
        .then(getTicketRes => {
          this.pickUpTickets = getTicketRes.data;
        })
        .catch(getTicketErr => {
          console.log("getTicketErr: ", getTicketErr);
        });
      
      // get products
      axios
        .get(`${this.d.apiDomain}/system/accounts/${this.d.accountId}/products`)
        .then((response) => {
          this.categories = response.data;
          this.products = this.categories[0].products;
          this.selectedCategoryId = this.categories[0].categoryId;
          this.selectedCategoryName = this.categories[0].categoryName;
          // get cart products for initial use
          // init: products, displayCartProducts
          axios
            .get(
              `${this.d.apiDomain}/session/cart?accountId=${this.d.accountId}`
            )
            .then((response) => {
              this.cartProducts = response.data;
              this.cartProducts.forEach((cartProduct) => {
                this.categories.forEach((category) => {
                  category.products.forEach((product) => {
                    if (product.productId == cartProduct.productId) {
                      product.qty =
                        Number(product.qty) + Number(cartProduct.qty);
                      product.class =
                        cartProduct.qty == 0
                          ? "clearfix"
                          : "clearfix the_selected";
                    }
                  });
                });
              });
            });

          // get cartTickets
          axios
            .get(
              `${this.d.apiDomain}/session/ticket/cart?accountId=${this.d.accountId}`
            )
            .then((response) => {
              this.cartTickets = response.data;
            });

          axios
            .get(
              `${this.d.apiDomain}/system/accounts/${this.d.accountId}/business/info?userId=${this.userId}`
            )
            .then((response) => {
              if (response.data) {
                this.businessPubInfo = response.data;
                this.isStoreInfo = true;
                this.isCalorie = this.businessPubInfo.isCalorie ? true : false;
                this.businessPubInfo.isRebuild = this.businessPubInfo.isRebuild
                  ? true
                  : false;
                this.shopPrivacy = this.businessPubInfo.privacy;
              }
              if (
                !this.businessPubInfo.isRead &&
                this.businessPubInfo.content &&
                this.businessPubInfo.content !== '{"ops":[{"insert":"\\n"}]}'
              ) {
                this.$refs.store_notice.click();
              }

              axios
                .get(
                  `${this.d.apiDomain}/system/accounts/${this.d.accountId}/menu-style`
                )
                .then((response) => {
                  if (response.data) {
                    this.isStyleOne = response.data.isNewStyle ? false : true;
                    this.showResult();
                    this.isStoreInfo = true;
                  }
                  // groupbuy
                  this.checkGroupbuyStatus();
                })
                .catch((err) => {
                  console.log("bus info err: ", err);
                  this.isLoaded = true;
                });
            })
            .catch((err) => {
              console.log("bus info err: ", err);
            });
        });
    });
    new Swiper(".swiper-container", {
      navigation: {
        nextEl: ".swiper-button-next"
      },
      slidesPerView: "auto",
      spaceBetween: 5,
      freeMode: true,
      centeredSlides: false,
      // slideToClickedSlide: true,
      observer: true, //修改swiper自己或子元素時，自動初始化swiper
      observeParents: true //修改swiper的父元素時，自動初始化swiper
    });

    $(function() {
      // top 菜單
      $().on("swipeleft", function() {
        console.log("swipeleft");
        $(".swiper-slide p.btn_in")
          .parent()
          .next()
          .find("p")
          .parent()
          .click();
        var mySwiper = $(".swiper-container")[0].swiper;
        mySwiper.slideNext();
      });
      $().on("swiperight", function() {
        $(".swiper-slide p.btn_in")
          .parent()
          .prev()
          .find("p")
          .parent()
          .click();
        var mySwiper = document.querySelector(".swiper-container").swiper;
        mySwiper.slidePrev();
      });
    });
  },
  updated: function() {
    // this.categories.forEach(category => {
    // 	if (category.categoryId == this.selectedCategoryId) {
    // 		this.products = category.products;
    // 		console.log("products: ", this.products);
    // 		this.selectedCategoryName = category.categoryName;
    // 	}
    // });
  },
  methods: {
    minusMultiCheckbox(item, option) {
      item.qty--;
      option.qty--;
      if(item.qty < 1) {
        item.style = {
          "display": "none"
        };
        item.qty = 0;
        let _itemIndex = option.selectedValues.findIndex((_item) => {
          return _item.id === item.id;
        });
        option.selectedValues.splice(_itemIndex, 1);
      }
      this.options = Object.assign([], this.options);
    },
    isMultiCheckbox(item, option) {
      var flag = false;
      let itemsMax = option.values.reduce((accumulator, item) => {
        accumulator += item.constraints.max;
        return accumulator;
      }, 0);
      if(option.constraints.min > 1 || option.constraints.max < itemsMax || item.constraints.max > 1) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    showResetAllNum(items) {
      let result = items.reduce((accumulator, item) => {
        if(item.qty > 0) {
          accumulator += item.qty;
        }
        return accumulator;
      }, 0)
      return result > 0;
    },
    resetSetNum(items, option) {
      option.qty = 0;
      items.forEach(item => {
        item.qty = 0;
        item.style = {
          "display": "none"
        };
      });
      let optionIndex = this.cartOptions.findIndex(o => o.id === option.id);
      this.cartOptions.splice(optionIndex, 1);
      option.selectedValues = [];
      this.options = Object.assign([], this.options);
      
    },
    checkIsLargeOrder() {
      let countTotal = this.countTotal();
      let config = {
        url: `${this.d.apiDomain}/api/accounts/${this.d.accountId}/large-order`,
        method: 'POST',
        data: {
          countTotal: countTotal
        }
      };
      return axios(config);
    },
    moveCheck(_dg, dom) {
      let s = this.touchObj.touches.start,
        m = this.touchObj.touches.move,
        x = s.clientX - m.clientX,
        y = s.clientY - m.clientY;
      if (_dg) {
        let h = m.clientY - dom.offsetHeight * 0.5,
          w = m.clientX - dom.offsetWidth * 0.5;
        dom.style.top = h + "px";
        dom.style.left = w + "px";
      } else {
        if (Math.abs(x) > 50 || Math.abs(y) > 50) this.touchObj.ismoved = !0;
      }
    },
    touchCheck() {
      let s = this.touchObj.touches.start,
        e = this.touchObj.touches.end,
        x = s.clientX - e.clientX,
        y = s.clientY - e.clientY,
        X = Math.abs(x),
        Y = Math.abs(y);
      //0 tap  1 上 -1下  2 左 -2 右  3 触摸
      //0 tap  1 up -1 down  2 left -2 right  3 swipe
      if (X < 10 && Y < 10) return 0;
      else {
        if (X > Y) {
          if (Y > 50) return 3;
          else return x > 0 ? 2 : -2;
        } else {
          if (X > 50) return 3;
          else return y > 0 ? 1 : -1;
        }
      }
    },
    typeCheck(d) {
      let ismoved = this.touchObj.ismoved;
      switch (this.touchCheck()) {
        case -2:
          /*右滑  swipe right*/
          return d > 5e2 ? 6 : 5;
        case -1:
          /*下滑 swipe down*/
          return d > 5e2 ? 6 : 3;
        case 0:
          /*轻触 tap *长按 long tap*/
          var n = d < 5e2 ? 0 : 1;
          return ismoved ? 6 : n;
        case 1:
          /*上滑 swipe up*/
          return d > 5e2 ? 6 : 2;
        case 2:
          /*左滑 swipe left*/
          return d > 5e2 ? 6 : 4;
        default:
          /*触摸 swipe*/
          return 6;
      }
    },
    restartGroupbuy() {
      let restartGroupbuyConfig = {
        url: `${this.d.apiDomain}/api/groupbuy/${this.groupbuy.id}`,
        method: `PUT`,
        data: {
          isOnGoing: !this.groupbuy.isOnGoing
        }
      };
      axios(restartGroupbuyConfig)
        .then((restartGroupbuyConfigRes) => {
          console.log(
            "restartGroupbuyConfigRes.data: ",
            restartGroupbuyConfigRes.data
          );
          this.groupbuy = restartGroupbuyConfigRes.data;
          console.log("this.groupbuy: ", this.groupbuy);
        })
        .catch((restartGroupbuyConfigErr) => {
          console.log("restartGroupbuyConfigErr: ", restartGroupbuyConfigErr);
          swal.fire("重啟失敗");
        });
    },
    redirectToOrderFlow: function() {
      let liffId = this.d.liffId;
      window.location.replace(
        `${this.d.apiDomain}/views/liff/liff2-order-flow?accountId=${this.d.accountId}&userId=${this.userId}&liffId=${liffId}&source=${this.d.source}&token=${this.d.token}&gt=${this.gt}&groupId=${this.groupbuy.id}`
      );
    },
    checkGroupbuyStatus: function() {
      let groupbuyConfig = {
        url: `${this.d.apiDomain}/api/groupbuy/master/status`,
        method: "post",
        data: {
          userId: this.userId,
          accountId: this.d.accountId
        }
      };
      axios(groupbuyConfig)
        .then((response) => {
          let d = response.data;
          this.groupbuy = d;
          this.isLoaded = true;
        })
        .catch((err) => {
          console.log("groupbuy err: ", err);
        });
    },
    createGroupbuy: function() {
      this.$refs.groupbuy_create_cancel.click();
      this.isLoaded = false;
      let createGroupbuyConfig = {
        url: `${this.d.apiDomain}/api/groupbuy`,
        method: "post",
        data: {
          userId: this.userId,
          accountId: this.d.accountId
        }
      };
      axios(createGroupbuyConfig)
        .then((createGroupbuyConfigRes) => {
          this.groupbuy = createGroupbuyConfigRes.data;
          console.log("this.$refs.groupbuy_share: ", this.$refs.groupbuy_share);
          this.$refs.groupbuy_share.click();
          this.isLoaded = true;
        })
        .catch((createGroupbuyConfigErr) => {
          console.log("createGroupbuyConfigErr: ", createGroupbuyConfigErr);
          this.isLoaded = true;
        });
    },
    cancelGroupbuy: function() {
      console.log("this.groupbuy: ", this.groupbuy);
      this.$refs.groupbuy_cancel.click();

      let cancelConfig = {
        url: `${this.d.apiDomain}/api/groupbuy/${this.groupbuy.id}`,
        method: "DELETE"
      };
      console.log("cancelConfig: ", cancelConfig);
      axios(cancelConfig)
        .then((groupbuyCancelRes) => {
          console.log("groupbuyCancelRes: ", groupbuyCancelRes);
          // update groupbuy obj
          this.groupbuy = groupbuyCancelRes.data;
        })
        .catch((groupbuyCancelErr) => {
          console.log("groupbuyCancelErr: ", groupbuyCancelErr);
        });
    },
    rebuidCart: function(orderId) {
      this.isLoaded = false;
      let rebuildConfig = {
        url: `${this.d.apiDomain}/api/orders/${orderId}/rebuild`,
        method: "POST"
      };
      axios(rebuildConfig)
        .then((res) => {
          console.log("res: ", res.data);
          this.cartProducts = res.data.cartProducts;
          console.log("this.cartProducts: ", this.cartProducts);
          this.categories.forEach((category) => {
            category.products.forEach((product) => {
              product.qty = 0;
              this.cartProducts.forEach((cartProduct) => {
                if (product.productId == cartProduct.productId) {
                  product.qty = cartProduct.qty;
                  product.class =
                    cartProduct.qty == 0 ? "clearfix" : "clearfix the_selected";
                }
              });
            });
          });

          let config = {
            method: "post",
            url: `${this.d.apiDomain}/session/cart`,
            data: {
              cartData: this.cartProducts,
              accountId: this.d.accountId
            }
          };
          axios(config)
            .then((response) => {
              this.isLoaded = true;
              console.log("post cart session: ", response.data);
            })
            .catch((err) => {
              this.isLoaded = true;
              console.log("err: ", err.stack);
            });
        })
        .catch((err) => {
          this.isLoaded = true;
          console.log("err: ", err);
          alert(err.message);
        });
    },
    storeInfoClick: function() {
      this.$refs.store_notice.click();
    },
    storeInfoClicked: function() {
      axios
        .put(
          `${this.d.apiDomain}/system/accounts/${this.d.accountId}/business/info?userId=${this.userId}`
        )
        .then((response) => {
          console.log("response: ", response);
        })
        .catch((err) => {
          console.log("bus info err: ", err);
        });
    },
    theKey2: function(id) {
      return `main-${id}`;
    },
    theKey: function(id) {
      return `sub-${id}`;
    },
    categoryBtnIn: function(targetCategoryId) {
      if (targetCategoryId == this.selectedCategoryId) {
        return true;
      } else {
        return false;
      }
    },
    selectCategory: function(categoryId) {
      this.searchStr = "";
      this.selectedCategoryId = categoryId;
    },
    selectCategoryList: function(categoryId) {
      this.searchStr = "";
      $(".menu_all").slideToggle();
      this.selectedCategoryId = categoryId;
    },
    searchInCategory: function() {
      if (this.searchStr) {
        // get global products
        var globalProducts = [];
        this.categories.forEach((c) => {
          globalProducts = c.products.concat(globalProducts);
        });
        // backup this.products
        this.productsBk = this.searchStr
          ? this.products.slice()
          : this.productsBk.slice();
        // update this.products
        this.products = globalProducts;
        this.selectedCategoryName = "商品搜尋結果";
      } else {
        // no searchStr --> reset
        this.categories.forEach((category) => {
          if (category.categoryId == this.selectedCategoryId) {
            this.products = category.products;
            this.selectedCategoryName = category.categoryName;
          }
        });
      }
      // filter
      this.products.forEach((p) => {
        if (p.productName.indexOf(this.searchStr) < 0) {
          p.isShow = 0;
        } else {
          p.isShow = 1;
        }
      });
    },
    setProductImage: function(productImageUrl) {
      if (productImageUrl) {
        return `background-image: url(${productImageUrl})`;
      } else {
        return "";
      }
      // productImageUrl = productImageUrl ? productImageUrl : '';
    },
    productMinus: function(product) {
      console.log(product);
      this.$refs.shopping_cart.click();
    },
    chooseProduct: function(product) {
      function checkIsOrderAvaliable(that) {
        return !that.businessPubInfo.isEnabled;
      }
      function checkIsSoldOut(that, product) {
        return !that.checkIfSoldOut(product);
      }
      function reset(that) {
        that.options = [];
        that.ticketOptions = [];
        that.subOptions = [];
        that.ticketSubOptions = [];
        that.cartOptions = [];
        that.ticketCartOptions = [];
        that.cartSubOptions = [];
        that.ticketCartSubOptions = [];
        that.isLoaded = false;
      }
      function setup(that) {
        that.selectedProduct = product;
        that.selectedProductId = product.productId;
        that.disableButton(); // disableButton
        that.selectedProductQty = 1;
      }
      function fetchOptions(that, _productId) {
        let config = {
          method: "get",
          url: `${that.d.apiDomain}/system/products/${_productId}/option`
        };

        axios(config)
          .then((response) => {
            that.isLoaded = true;
            that.enableButton();
            let components = response.data.components;
            that.options = components;
            console.log("components: ", components)
            if(that.options && that.options.length > 0) {
              that.options.forEach((question) => {
                question.qty = 0;
                if(question && question.values && question.values.length > 0) {
                  question.values.forEach(item => {
                    item.style = {
                      display: "none"
                    }
                  });
                }
              });
            }
            that.$refs.food_items.click();
          })
          .catch((err) => {
            console.log(err);
            that.isLoaded = true;
            swal.fire("此商品目前無法訂購");
          });
      }
      let that = this;
      if (checkIsOrderAvaliable(that)) {
        swal.fire("目前暫停點餐");
      } else if (checkIsSoldOut(that, product)) {
        reset(that);
        setup(that);
        let _product = product;
        if (_product !== undefined) {
          // product level 2
          let _productId = _product.productId;
          fetchOptions(that, _productId);
        } else {
          this.enableButton(); // enableButton
          // return 0;
        }
      }
    },
    choosePickUp: function(ticket) {
      console.log("ticket: ", ticket)
      function reset(that) {
        that.options = [];
        that.ticketOptions = [];
        that.subOptions = [];
        that.ticketSubOptions = [];
        that.cartOptions = [];
        that.ticketCartOptions = [];
        that.cartSubOptions = [];
        that.ticketCartSubOptions = [];
        that.isLoaded = false;
      }
      function fetchOptions(that, _productId) {
        let config = {
            method: "get",
            url: `${that.d.apiDomain}/system/products/${_productId}/option`
          };

          axios(config)
            .then((response) => {
              console.log("fetch components: ", response.data)
              that.isLoaded = true;
              that.enableButton();
              let components = response.data.components;
              that.ticketOptions = components;
              that.$refs.pick_up.click();
            })
            .catch((err) => {
              console.log(err);
              that.isLoaded = true;
              swal.fire("此商品目前無法訂購");
            });
      }
      reset(this);
      this.selectedTicket = ticket;
      let that = this;
      let _product = ticket;
      if (_product !== undefined) {
        // product level 2
        let _productId = _product.productId;
        if(ticket.ticketStatus !== 'expired') {
          fetchOptions(that, _productId);
        } else {
          this.isLoaded = true;
          swal.fire('寄杯憑證已超過使用期限')
        }
      } else {
        this.enableButton(); // enableButton
        // return 0;
      }
    },
    cartProductMinus: function(cartProduct) {
      this.disableButton(); // disableButton
      let _cartProduct = cartProduct;
      let _productId = cartProduct.productId;
      if (_cartProduct !== undefined && _cartProduct.qty != 0) {
        _cartProduct.qty = _cartProduct.qty == 0 ? 0 : _cartProduct.qty - 1;

        // Find product from categories
        var _product = {};
        this.categories.find((category) => {
          _product = category.products.find(
            (product) => product.productId == _productId
          );
          if (_product) return true;
          else return false;
        });
        if (_product) {
          _product.qty = this.calSameProductQty(_productId);
        }

        // remove zero number product
        this.cartProducts.forEach((produdct, index) => {
          if (produdct.qty == 0) {
            this.cartProducts.splice(index, 1);
          }
        });
        let config = {
          method: "post",
          url: `${this.d.apiDomain}/session/cart`,
          data: {
            cartData: this.cartProducts,
            accountId: this.d.accountId
          }
        };
        axios(config)
          .then(() => {
            this.enableButton();
          })
          .catch((err) => {
            console.log("err: ", err.stack);
          });
      } else {
        this.enableButton(); // enableButton
      }
    },
    cartProductPlus: function(cartProduct) {
      this.disableButton(); // disableButton
      var _cartProduct = cartProduct;
      var _productId = cartProduct.productId;
      if (_cartProduct !== undefined) {
        _cartProduct.qty++;

        // Find product from categories
        var _product = {};
        this.categories.find((category) => {
          _product = category.products.find(
            (product) => product.productId == _productId
          );
          if (_product) return true;
          else return false;
        });
        if (_product) {
          _product.qty = this.calSameProductQty(_productId);
        }

        // remove zero number product
        this.cartProducts.forEach((produdct, index) => {
          if (produdct.qty == 0) {
            this.cartProducts.splice(index, 1);
          }
        });
        console.log("cartProductPlus this.cartProducts: ", this.cartProducts);
        let config = {
          method: "post",
          url: `${this.d.apiDomain}/session/cart`,
          data: {
            cartData: this.cartProducts,
            accountId: this.d.accountId
          }
        };
        axios(config)
          .then((response) => {
            console.log("post cart session: ", response.data);
            this.enableButton();
          })
          .catch((err) => {
            console.log("err: ", err.stack);
          });
      } else {
        this.enableButton(); // enableButton
      }
    },
    cartProductNumChange: function(cartProduct) {
      console.log("cartProductPlus cartProduct: ", cartProduct);
      cartProduct.qty = Number(cartProduct.qty);
      // isInteger
      if (Number.isInteger(cartProduct.qty)) {
        if (cartProduct.qty >= 300) {
          cartProduct.qty = 300;
        }
        if (cartProduct.qty < 0) {
          cartProduct.qty = 0;
        }
        this.disableButton(); // disableButton
        var _cartProduct = cartProduct;
        var _productId = cartProduct.productId;
        if (_cartProduct !== undefined) {
          var _product = {};
          this.categories.find((category) => {
            _product = category.products.find(
              (product) => product.productId == _productId
            );
            if (_product) return true;
            else return false;
          });
          if (_product) {
            _product.qty = this.calSameProductQty(_productId);
          }

          // remove zero number product
          this.cartProducts.forEach((produdct, index) => {
            if (produdct.qty == 0) {
              this.cartProducts.splice(index, 1);
            }
          });
          console.log("cartProductPlus this.cartProducts: ", this.cartProducts);
          let config = {
            method: "post",
            url: `${this.d.apiDomain}/session/cart`,
            data: {
              cartData: this.cartProducts,
              accountId: this.d.accountId
            }
          };
          axios(config)
            .then((response) => {
              console.log("post cart session: ", response.data);

              this.enableButton();
            })
            .catch((err) => {
              console.log("err: ", err.stack);
            });
        } else {
          this.enableButton(); // enableButton
        }
      } else {
        // floor
        cartProduct.qty = Math.floor(cartProduct.qty);
        swal.fire("請輸入整數");
        return;
      }
    },
    count: function() {
      let products = this.cartProducts;
      let amountArr = products.map((product) => {
        return (
          (Number(product.productAmount) + Number(product.addonAmt)) *
          product.qty
        );
      });
      let qtyArr = products.map((product) => {
        return Number(product.qty);
      });
      var totalCalorie = 0;
      if (this.isCalorie) {
        let calorieArr = products.map((product) => {
          let productCalorie = product.calorie || 0;
          let addonCalorie = product.addonCalorie || 0;
          return (Number(productCalorie) + Number(addonCalorie)) * product.qty;
        });
        if (calorieArr.length != 0) {
          totalCalorie = calorieArr.reduce((accumulator, currentValue) => {
            return accumulator + Number(currentValue);
          }, 0);
        } else {
          totalCalorie = 0;
        }
      }

      if (amountArr.length != 0) {
        var totalAmount = amountArr.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        });
      } else {
        totalAmount = 0;
      }
      if (qtyArr.length != 0) {
        var totalQty = qtyArr.reduce((accumulator, currentValue) => {
          return accumulator + Number(currentValue);
        }, 0);
      } else {
        totalQty = 0;
      }

      return {
        totalAmount,
        totalQty,
        totalCalorie
      };
    },

    /** display in cart */
    displayOriginSingleAmountInCart(product) {
      return product.productAmount;
    },
    displaySignOfSingleProductAddonInCart(product) {
      return product.addonAmt < 0 ? "-" : "+";
    },
    displaySingleProductAddonAmountInCart(product) {
      return Math.abs(product.addonAmt);
    },
    displaySignOfSingleProductAmountWithAddonAmountInCart(product) {
      return product.productAmount + product.addonAmt < 0 ? "-" : "";
    },
    displaySingleProductAmountWithAddonAmountInCart(product) {
      return Math.round(Math.abs(product.addonAmt + product.productAmount) * 1000) / 1000;
    },
    displaySingleSameProductAmountInCartSubtotal(ticket) {
      return Math.round(Math.abs(ticket.productAmount + ticket.addonAmt) * ticket.qty * 1000) / 1000;
    },
    checkIfDisplayCalorieWithCartProduct() {
      return this.isCalorie || false;
    },
    displaySingleSameProductsWithAddonsCalorieInCartSubtotal(product) {
      return (Number(product.calorie) + Number(product.addonCalorie)) * product.qty;
    },
    displayOriginSingleTicketAddonAmountInCart(ticket) {
      return Math.abs(ticket.addonAmt);
    },
    displayOriginSingleTicketAmountInCart(ticket) {
      return Math.abs(ticket.addonAmt);
    },
    displaySignOfSingleTicketAmountInCart(ticket) {
      return ticket.addonAmt < 0 ? "-" : "+";
    },
    displaySignOfTicketsAmountInCartSubtotal(ticket) {
      return ticket.addonAmt < 0 ? "-" : "";
    },
    displaySingleSameTicketsAmountInCartSubtotal(ticket) {
        return Math.abs(ticket.addonAmt) * ticket.qty || 0;
    },
    displaySingleSameTicketsWithAddonsCalorieInCartSubtotal(ticket) {
      return (Number(ticket.calorie) + Number(ticket.addonCalorie)) * ticket.qty;
    },

    checkIfDisplayCalorieWithCartTicket() {
      return this.isCalorie || false;
    },
    countTicket: function() {
      let products = this.cartTickets;
      let qtyArr = products.map((product) => {
        return Number(product.qty);
      });
      var totalCalorie = 0;
      if (this.isCalorie) {
        let calorieArr = products.map((product) => {
          let productCalorie = product.calorie || 0;
          let addonCalorie = product.addonCalorie || 0;
          return (Number(productCalorie) + Number(addonCalorie)) * product.qty;
        });
        if (calorieArr.length != 0) {
          totalCalorie = calorieArr.reduce((accumulator, currentValue) => {
            return accumulator + Number(currentValue);
          }, 0);
        } else {
          totalCalorie = 0;
        }
      }
      let amountArr = products.map((product) => {
        return (
          // (Number(product.productAmount) + Number(product.addonAmt)) *
          (Number(product.addonAmt)) *
          product.qty
        );
      });

      if (qtyArr.length != 0) {
        var totalQty = qtyArr.reduce((accumulator, currentValue) => {
          return accumulator + Number(currentValue);
        }, 0);
      } else {
        totalQty = 0;
      }
      if (amountArr.length != 0) {
        var totalAmount = amountArr.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        });
      } else {
        totalAmount = 0;
      }

      return {
        totalQty,
        totalAmount,
        totalCalorie
      };
    },
    countTotal() {
      let totalQty = this.count().totalQty + this.countTicket().totalQty;
      let totalAmount = this.count().totalAmount + this.countTicket().totalAmount;
      let totalCalorie = this.count().totalCalorie + this.countTicket().totalCalorie;
      return {
        totalQty,
        totalAmount,
        totalCalorie
      }
    },
    disableButton: function() {
      this.isDisabled = true;
    },
    enableButton: function() {
      this.isDisabled = false;
    },
    checkCart: function() {
      // remove zero number product
      this.cartProducts.forEach((produdct, index) => {
        if (produdct.qty == 0) {
          this.cartProducts.splice(index, 1);
        }
      });
      let qty = this.cartProducts.reduce((accumulator, product) => {
        return accumulator + product.qty;
      }, 0);
      let ticketQty = this.cartTickets.reduce((accumulator, product) => {
        return accumulator + product.qty;
      }, 0);
      if (qty == 0 && ticketQty == 0) {
        swal.fire("請選擇商品");
      } else {
        // check if cartProducts exist
        let checkProductArr = this.cartProducts.map((cartProdudct) => {
          return this.categories.findIndex((category) => {
            let ifIndex = category.products.findIndex(
              (product) => product.productId == cartProdudct.productId
            );
            if (ifIndex != -1) return true;
            else return false;
          });
        });

        if (checkProductArr.includes(-1)) {
          swal
            .fire({
              text: `購物車包含已下架商品，確定要送出訂單嗎？`,
              icon: "info",
              showCancelButton: true,
              confirmButtonText: '確認送出',
              cancelButtonText: '取消',
              confirmButtonColor: '#f0941d',
              cancelButtonColor: '#979797', 
              // buttons: {
              //   cancel: {
              //     text: "取消",
              //     value: null,
              //     visible: true,
              //     className: "",
              //     closeModal: true
              //   },
              //   confirm: {
              //     text: "確認送出",
              //     value: true,
              //     visible: true,
              //     className: "",
              //     closeModal: false
              //   }
              // }
            })
            .then((res) => {
              if (res.isConfirmed) {
                this.checkProductEnough();
              }
            });
        } else {
          this.checkProductEnough();
        }
      }
    },
    checkProductEnough: function() {
      // check if cartProducts were valid
      let verifyConfig = {
        url: `${this.d.apiDomain}/system/cart/verify`,
        method: "POST",
        data: {
          accountId: this.d.accountId,
          cartProducts: this.cartProducts
        }
      };
      var displayMessage = "";
      axios(verifyConfig)
        .then((verifyRes) => {
          displayMessage = displayMessage + "\n" + verifyRes.data.display;
          if (verifyRes.data.invalidExist) {
            swal
              .fire({
                // title: "商品數量不足或已下架，請檢查購物車之商品",
                title: "因近期菜單異動，請重新將商品加入購物車，謝謝您！",
                // text: displayMessage
              })
              .then((res) => {
                console.log(res);
                this.cartProducts = verifyRes.data.cartProducts;
                this.updateCategoryProductQty();
              });
          } else {
            this.checkIsLargeOrder()
              .then(checkIsLargeOrderRes => {
                let phone = this.businessPubInfo.businessPhone ? `（電話: ${this.businessPubInfo.businessPhone}）` : "";
                if(checkIsLargeOrderRes.data.isLargeOrder) {
                  let amountTh = checkIsLargeOrderRes.data.amountTh;
                  let qtyTh = checkIsLargeOrderRes.data.qtyTh;
                  let displayMessage = `此訂單的「金額上限為${amountTh}」、「數量上限為${qtyTh}」，請修改訂單以送出訂單，或請直接聯繫商店${phone}。`
                  swal
                    .fire({
                      title: "此筆訂單超過下單限制",
                      text: displayMessage
                    })
                    .then((res) => {
                      console.log(res);
                    });
                } else {
                  window.location.replace(this.toPay);
                }
              })
              .catch(checkIsLargeOrderErr => {
                console.log("checkIsLargeOrderErr: ", checkIsLargeOrderErr);
                window.location.replace(this.toPay);
              });
          }
        })
        .catch((err) => {
          console.log("check number err: ", err);
        });
    },
    callSub: function(optionId, itemId, subItems) {
      let config = {
        method: "get",
        url: `${this.d.apiDomain}/system/products/${itemId}/option/sub`
      };
      if (subItems) {
        this.isLoaded = false;
        axios(config)
          .then((response) => {
            this.isLoaded = true;
            let components = response.data.components;
            this.subOptions = components;
            this.selectedItemId = itemId;
            this.selectedOptionId = optionId;
            this.$refs.food_items2.click();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    ticketCallSub: function(optionId, itemId, subItems) {
      let config = {
        method: "get",
        url: `${this.d.apiDomain}/system/products/${itemId}/option/sub`
      };
      if (subItems) {
        this.isLoaded = false;
        axios(config)
          .then((response) => {
            this.isLoaded = true;
            let components = response.data.components;
            this.ticketSubOptions = components;
            this.selectedItemId = itemId;
            this.selectedOptionId = optionId;
            this.$refs.ticket_items2.click();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    createSubOptionKey: function(subItemId) {
      let str = this.selectedItemId.toString() + "-" + subItemId;
      return str;
    },
    optionRadioCheck: function(e, itemId, subItems) {
      if (e.target.checked) {
        let selectedOptionId = e.target.name;
        let selectedItemId = e.target.id;
        let checkedRadio = this.cartOptions.find(function(element) {
          return element.id == selectedOptionId; // option id
        });
        let _option = this.options.find(
          (option) => option.id == selectedOptionId
        );
        let _value = _option.values.find((value) => value.id == selectedItemId);
        _option.selectedValues = [_value];
        if (checkedRadio) {
          checkedRadio.selectedValues = [_value]; // item id
        } else {
          this.cartOptions.push(_option);
        }
        this.callSub(selectedOptionId, itemId, subItems);
      }
    },
    ticketOptionRadioCheck: function(e, itemId, subItems) {
      if (e.target.checked) {
        let selectedOptionId = e.target.name;
        let selectedItemId = e.target.id;
        let checkedRadio = this.ticketCartOptions.find(function(element) {
          return element.id == selectedOptionId; // option id
        });
        let _option = this.ticketOptions.find(
          (option) => option.id == selectedOptionId
        );
        let _value = _option.values.find((value) => value.id == selectedItemId);
        _option.selectedValues = [_value];
        if (checkedRadio) {
          checkedRadio.selectedValues = [_value]; // item id
        } else {
          this.ticketCartOptions.push(_option);
        }
        this.ticketCallSub(selectedOptionId, itemId, subItems);
      }
    },
    optionCheckboxCheck: function(e, itemId, subItems, item, option) {
      let selectedOptionId = e.target.name;
      let selectedItemId = e.target.id;
      if(this.isMultiCheckbox(item, option)) {
        this.isLoaded = false;
        // 多選多
        option.isMultiCheckbox = true;
        option.qty++;
        if(option.qty > option.constraints.max) {
          option.qty = option.constraints.max;
          let msg = `「${option.label}」可選數量：${option.constraints.max}項`;
          swal.fire({
            title: msg,
            showDenyButton: true,
            confirmButtonText: `確定`,
            denyButtonText: `重新選擇`,
            confirmButtonColor: '#f0941d',
            denyButtonColor: '#979797',
            reverseButtons: true
          }).then((result) => {
            if (result.isDenied) {
              this.resetSetNum(option.values, option);
            }
          });
          this.isLoaded = true;
          return;
        }
        item.qty = typeof item.qty === 'number' ? item.qty + 1 : 1;
        if(item.qty > item.constraints.max) {
          option.qty--;
          item.qty = item.constraints.max;
          let msg = `「${item.label}」可選數量：${item.constraints.max}項`;
          swal.fire({
            title: msg,
            showDenyButton: true,
            confirmButtonText: `確定`,
            denyButtonText: `重新選擇`,
            confirmButtonColor: '#f0941d',
            denyButtonColor: '#979797',
            reverseButtons: true
          }).then((result) => {
            if (result.isDenied) {
              this.resetSetNum(option.values, option);
            }
          });
          this.isLoaded = true;
          return;
        }
        item.style = {
          "display": "block"
        };
        
        if(!option.selectedValues) option.selectedValues = [];
        let _index = option.selectedValues.findIndex((_item) => {
          return _item.id === item.id;
        });
        if(_index !== -1) {
          option.selectedValues.splice(_index, 1, item);
        } else {
          option.selectedValues.push(item);
        }

        let _cartOptionIndex = this.cartOptions.findIndex(_option => {
          return _option.id === option.id;
        });
        if(_cartOptionIndex === -1) {
          this.cartOptions.push(option);
        }
        this.options = Object.assign([], this.options);
        this.isLoaded = true;
      } else {
        if (e.target.checked) {
          let checked = this.cartOptions.find(function(element) {
            return element.id == selectedOptionId;
          });
          let _option = this.options.find(
            (option) => option.id == selectedOptionId
          );
          let _value = _option.values.find((value) => value.id == selectedItemId);
          if (checked) {
            checked.selectedValues.push(_value);
          } else {
            _option.selectedValues = [_value];
            this.cartOptions.push(_option);
          }
          this.callSub(selectedOptionId, itemId, subItems);
        } else {
          let unchecked = this.cartOptions.find(
            (element) => element.id == selectedOptionId
          );

          let uncheckedValueIndex = -1;
          unchecked.selectedValues.find((value, index) => {
            if (value.id == selectedItemId) uncheckedValueIndex = index;
            return value.id == selectedItemId;
          });
          if (uncheckedValueIndex > -1) {
            delete unchecked.selectedValues[uncheckedValueIndex].subOptions;
            unchecked.selectedValues.splice(uncheckedValueIndex, 1);
          }
          // check length 0 array
          this.cartOptions.forEach((option, index) => {
            if (option.selectedValues && option.selectedValues.length == 0) {
              this.cartOptions.splice(index, 1);
            }
          });
        }
      }
    },
    ticketOptionCheckboxCheck: function(e, itemId, subItems) {
      let selectedOptionId = e.target.name;
      let selectedItemId = e.target.id;
      if (e.target.checked) {
        let checked = this.ticketCartOptions.find(function(element) {
          return element.id == selectedOptionId;
        });
        let _option = this.ticketOptions.find(
          (option) => option.id == selectedOptionId
        );
        let _value = _option.values.find((value) => value.id == selectedItemId);
        if (checked) {
          checked.selectedValues.push(_value);
        } else {
          _option.selectedValues = [_value];
          this.ticketCartOptions.push(_option);
        }
        this.ticketCallSub(selectedOptionId, itemId, subItems);
      } else {
        let unchecked = this.ticketCartOptions.find(
          (element) => element.id == selectedOptionId
        );

        let uncheckedValueIndex = -1;
        unchecked.selectedValues.find((value, index) => {
          if (value.id == selectedItemId) uncheckedValueIndex = index;
          return value.id == selectedItemId;
        });
        if (uncheckedValueIndex > -1) {
          delete unchecked.selectedValues[uncheckedValueIndex].subOptions;
          unchecked.selectedValues.splice(uncheckedValueIndex, 1);
        }
        // check length 0 array
        this.ticketCartOptions.forEach((option, index) => {
          if (option.selectedValues && option.selectedValues.length == 0) {
            this.ticketCartOptions.splice(index, 1);
          }
        });
      }
    },
    subOptionRadioCheck: function(e) {
      let selectedOptionId = e.target.name;
      let selectedItemId = e.target.id;
      let _selectedOptionId = this.selectedOptionId;
      let _selectedItemId = this.selectedItemId;
      if (e.target.checked) {
        let _cartOptions = this.cartOptions;
        let _option = _cartOptions.find(
          (option) => option.id == _selectedOptionId
        );
        let _value = _option.selectedValues.find(
          (selectedValue) => selectedValue.id == _selectedItemId
        );
        let _subOption = this.subOptions.find(
          (subOption) => subOption.id == selectedOptionId
        );
        let _subValue = _subOption.values.find(
          (subValue) => subValue.id == selectedItemId
        );
        if (_value.subOptions) {
          var checkedRadio = _value.subOptions.find(function(element) {
            return element.id == selectedOptionId;
          });
        }
        if (checkedRadio) {
          checkedRadio.selectedValues = [_subValue];
        } else {
          if (!_value.subOptions) _value.subOptions = [];
          _subOption.selectedValues = [_subValue];
          _value.subOptions.push(_subOption);
        }
      }
    },
    ticketSubOptionRadioCheck: function(e) {
      let selectedOptionId = e.target.name;
      let selectedItemId = e.target.id;
      let _selectedOptionId = this.selectedOptionId;
      let _selectedItemId = this.selectedItemId;
      if (e.target.checked) {
        let _cartOptions = this.ticketCartOptions;
        let _option = _cartOptions.find(
          (option) => option.id == _selectedOptionId
        );
        let _value = _option.selectedValues.find(
          (selectedValue) => selectedValue.id == _selectedItemId
        );
        let _subOption = this.subOptions.find(
          (subOption) => subOption.id == selectedOptionId
        );
        let _subValue = _subOption.values.find(
          (subValue) => subValue.id == selectedItemId
        );
        if (_value.subOptions) {
          var checkedRadio = _value.subOptions.find(function(element) {
            return element.id == selectedOptionId;
          });
        }
        if (checkedRadio) {
          checkedRadio.selectedValues = [_subValue];
        } else {
          if (!_value.subOptions) _value.subOptions = [];
          _subOption.selectedValues = [_subValue];
          _value.subOptions.push(_subOption);
        }
      }
    },
    subOptionCheckboxCheck: function(e) {
      let selectedOptionId = e.target.name;
      let selectedItemId = e.target.id;
      let _selectedOptionId = this.selectedOptionId;
      let _selectedItemId = this.selectedItemId;
      if (e.target.checked) {
        let _cartOptions = this.cartOptions;
        let _option = _cartOptions.find(
          (option) => {
            return option.id == _selectedOptionId;
          }
        );
        let _value = _option.selectedValues.find(
          (selectedValue) => selectedValue.id == _selectedItemId
        );
        let _subOption = this.subOptions.find(
          (subOption) => subOption.id == selectedOptionId
        );
        let _subValue = _subOption.values.find(
          (subValue) => subValue.id == selectedItemId
        );
        if (_value.subOptions) {
          var checked = _value.subOptions.find(function(element) {
            return element.id == selectedOptionId;
          });
        }
        if (checked) {
          checked.selectedValues.push(_subValue);
          checked.selectedValues = checked.selectedValues.reduce(
            (acc, current) => {
              const x = acc.find((value) => value.id === current.id);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            },
            []
          );
        } else {
          if (!_value.subOptions) _value.subOptions = [];
          _subOption.selectedValues = [_subValue];
          _value.subOptions.push(_subOption);
        }
      } else {
        let _cartOptions = this.cartOptions;
        let _option = _cartOptions.find(
          (option) => option.id == _selectedOptionId
        );
        let _value = _option.selectedValues.find(
          (selectedValue) => selectedValue.id == _selectedItemId
        );
        let unchecked = _value.subOptions.find(
          (element) => element.id == selectedOptionId
        );
        // console.log("index: ", unchecked.selectedValues.indexOf(selectedItemId))
        let uncheckedValueIndex = -1;
        unchecked.selectedValues.find((value, index) => {
          if (value.id == selectedItemId) uncheckedValueIndex = index;
          return value.id == selectedItemId;
        });
        if (uncheckedValueIndex > -1)
          unchecked.selectedValues.splice(uncheckedValueIndex, 1);
      }
    },
    ticketSubOptionCheckboxCheck: function(e) {
      let selectedOptionId = e.target.name;
      let selectedItemId = e.target.id;
      let _selectedOptionId = this.selectedOptionId;

      let _selectedItemId = this.selectedItemId;
      if (e.target.checked) {
        let _cartOptions = this.ticketCartOptions;
        let _option = _cartOptions.find(
          (option) => {
            return option.id == _selectedOptionId;
          }
        );
        let _value = _option.selectedValues.find(
          (selectedValue) => selectedValue.id == _selectedItemId
        );
        let _subOption = this.ticketSubOptions.find(
          (subOption) => subOption.id == selectedOptionId
        );
        let _subValue = _subOption.values.find(
          (subValue) => subValue.id == selectedItemId
        );
        if (_value.subOptions) {
          var checked = _value.subOptions.find(function(element) {
            return element.id == selectedOptionId;
          });
        }
        if (checked) {
          checked.selectedValues.push(_subValue);
          checked.selectedValues = checked.selectedValues.reduce(
            (acc, current) => {
              const x = acc.find((value) => value.id === current.id);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            },
            []
          );
        } else {
          if (!_value.subOptions) _value.subOptions = [];
          _subOption.selectedValues = [_subValue];
          _value.subOptions.push(_subOption);
        }
      } else {
        let _cartOptions = this.ticketCartOptions;
        let _option = _cartOptions.find(
          (option) => option.id == _selectedOptionId
        );
        let _value = _option.selectedValues.find(
          (selectedValue) => selectedValue.id == _selectedItemId
        );
        let unchecked = _value.subOptions.find(
          (element) => element.id == selectedOptionId
        );
        let uncheckedValueIndex = -1;
        unchecked.selectedValues.find((value, index) => {
          if (value.id == selectedItemId) uncheckedValueIndex = index;
          return value.id == selectedItemId;
        });
        if (uncheckedValueIndex > -1)
          unchecked.selectedValues.splice(uncheckedValueIndex, 1);
      }
    },
    optionConfirm: function() {
      // insert into db
      // let _selectedProductId = this.selectedProductId;
      let _cartOptions = this.cartOptions;
      // let _cartSubOptions = this.cartSubOptions;
      // let _cartProduct = this.cartProducts.find((cartProduct) => {
      //   return cartProduct.productId == _selectedProductId;
      // });
      // let _product = this.products.find(product => {
      // 	return product.productId == _selectedProductId;
      // });

      if (this.options.length > 0) {
        if (this.checkOptionRequired(this.options, _cartOptions)) {
          // insert into cart
          this.inserIntoCart();
        }
      } else {
        // insert into cart
        this.inserIntoCart();
      }
    },
    subOptionConfirm: function() {
      // let _selectedProductId = this.selectedProductId;
      let _cartOptions = this.cartOptions;
      // let _cartSubOptions = this.cartSubOptions;
      if (this.checkSubOptionRequired(this.subOptions, _cartOptions)) {
        this.$refs.food_items.click();
      }
    },
    ticketSubOptionConfirm: function() {
      // let _selectedProductId = this.selectedProductId;
      let _cartOptions = this.cartOptions;
      // let _cartSubOptions = this.cartSubOptions;
      if (this.checkSubOptionRequired(this.subOptions, _cartOptions)) {
        this.$refs.pick_up.click();
      }
    },
    addonsToString: function(addons) {
      let _options = [];
      let optionStr;
      addons.forEach((addon) => {
        if(addon.isMultiCheckbox) {
          addon.selectedValues.forEach((optionValue) => {
            let { label, price, qty } = optionValue;
            if (price != 0) {
              _options.push(
                `${label}*${qty} ${price < 0 ? "-" : "+"}$${Math.abs(price)*qty}`
              );
            } else {
              _options.push(`${label}*${qty}`);
            }
          });
        } else {
          addon.selectedValues.forEach((optionValue) => {
            let _subOptions = [];
            let { label, price } = optionValue;
            if (price != 0) {
              _options.push(
                `${label} ${price < 0 ? "-" : "+"}$${Math.abs(price)}`
              );
            } else {
              _options.push(`${label}`);
            }
            if (!optionValue.subItems) {
              console.log();
            } else {
              let subOptions = optionValue.subOptions;
              // sub optioins
              if (subOptions) {
                subOptions.forEach((subOption) => {
                  subOption.selectedValues.forEach((subOptionValue) => {
                    let { label, price } = subOptionValue;
                    if (price != 0) {
                      _subOptions.push(
                        `${label} ${price < 0 ? "-" : "+"}$${Math.abs(price)}`
                      );
                    } else {
                      _subOptions.push(`${label}`);
                    }
                  });
                });
                _options[_options.length - 1] =
                  _options[_options.length - 1] +
                  "(" +
                  _subOptions.join("、") +
                  ")";
              }
            }
          });
        }
      });
      optionStr = _options.join("/");
      // this.addonsCalAmt(addons);
      return optionStr;
    },
    addonsCalAmt: function(addons) {
      if (addons) {
        var amt = 0;
        addons.forEach((addon) => {
          if(addon.isMultiCheckbox) {
            addon.selectedValues.forEach((optionValue) => {
              let { price, qty } = optionValue;
              amt += price * qty;
            });
          } else {
            addon.selectedValues.forEach((optionValue) => {
              let { price } = optionValue;
              amt = amt + price;
              if (optionValue.subItems) {
                let subOptions = optionValue.subOptions;
                // sub optioins
                if (subOptions) {
                  subOptions.forEach((subOption) => {
                    subOption.selectedValues.forEach((subOptionValue) => {
                      let { price } = subOptionValue;
                      amt = amt + price;
                    });
                  });
                }
              }
            });
          }
        });
      } else {
        amt = 0;
      }
      return amt;
    },
    addonsCalCalorie: function(addons) {
      if (addons) {
        let _options = [];
        var calorie = 0;
        addons.forEach((addon) => {
          addon.selectedValues.forEach((optionValue) => {
            let { label } = optionValue;
            let addonCalorie = optionValue.calorie || 0;
            calorie = calorie + addonCalorie;
            _options.push(`${label}`);
            if (!optionValue.subItems) {
              console.log();
            } else {
              let subOptions = optionValue.subOptions;
              // sub optioins
              if (subOptions) {
                subOptions.forEach((subOption) => {
                  subOption.selectedValues.forEach((subOptionValue) => {
                    let addonCalorie = subOptionValue.calorie || 0;
                    calorie = calorie + addonCalorie;
                  });
                });
              }
            }
          });
        });
      } else {
        calorie = 0;
      }
      return calorie;
    },
    checkOptionRequired(originOptions, cartOptions) {
      var _ready = true;
      var _RequiredOptions = originOptions.filter(
        (option) => option.required == 1
      );
      if (cartOptions.length != 0) {
        originOptions.forEach((originOption) => {
          let required = originOption.required;
          let label = originOption.label;
          let optionId = originOption.id;
          
          if (required) {
            let cartOption = cartOptions.find(
              (cartOption) => cartOption.id == optionId
            );
            if (!cartOption) {
              swal.fire(`${label}為必填項目`);
              _ready = false;
            } else if (!cartOption.selectedValues) {
              swal.fire(`${label}為必填項目`);
              _ready = false;
            } else if (!cartOption.selectedValues.length) {
              swal.fire(`${label}為必填項目`);
              _ready = false;
            } else if (originOption.constraints && originOption.constraints.min > 0 && cartOption.isMultiCheckbox && cartOption.qty < originOption.constraints.min) {
              swal.fire(`${label}必選${originOption.constraints.min}項`);
              _ready = false;
            }
          }
        });
      } else if (_RequiredOptions.length != 0) {
        _ready = false;
        swal.fire("請選擇必選項目");
      }
      return _ready;
    },
    checkSubOptionRequired(originSubOptions, cartOptions) {
      var _ready = false;
      return originSubOptions.every((originOption) => {
        let required = originOption.required;
        let label = originOption.label;
        let values = originOption.values;
        if (required) {
          _ready = values.some((value) => {
            let cartOption = cartOptions.find(
              (cartOption) => cartOption.id == this.selectedOptionId
            );
            let selectedValue = cartOption.selectedValues.find(
              (selectedValue) => selectedValue.id == this.selectedItemId
            );
            var _exist = false;
            if (selectedValue.subOptions) {
              selectedValue.subOptions.forEach((subOption) => {
                subOption.selectedValues.forEach((subValue) => {
                  if (subValue.id == value.id) {
                    _exist = true;
                  }
                });
              });
              return _exist;
            }
          });
          if (!_ready) {
            swal.fire(`${label}必須選擇的`);
          }
          return _ready;
        }
        return true;
      });
    },
    adjustSelectedProductQty: function(type) {
      if (type == "plus") {
        this.selectedProductQty++;
      } else if (type == "minus") {
        if (this.selectedProductQty != 1) {
          this.selectedProductQty--;
        }
      }
    },
    checkIfSoldOut: function(product) {
      let isVisibled = product.isVisibled;
      let isStock = product.isStock;
      let numOfRemain = product.numOfRemain;
      var out = false;
      if (isVisibled && isStock && numOfRemain > 0) {
        out = false;
      } else if (isVisibled && !isStock) {
        out = false;
      } else {
        out = true;
      }
      return out;
    },
    checkIfProductRemain: function(product) {
      let isStock = product.isStock;
      return isStock;
    },
    checkIfProdutcEnough: function() {},
    checkProductExistInCart: function(productId) {
      let _index = this.cartProducts.findIndex((product) => {
        return product.productId == productId;
      });
      return _index != -1;
    },
    checkCategoryQty: function(category) {
      let qty = category.products.reduce((accumulator, product) => {
        return accumulator + product.qty;
      }, 0);
      return qty > 0;
    },
    calCategoryQty: function(category) {
      let qty = category.products.reduce((accumulator, product) => {
        return accumulator + Number(product.qty);
      }, 0);
      return qty;
    },
    checkTicketQty: function() {
      let qty = this.cartTickets.reduce((accumulator, product) => {
        return accumulator + product.qty;
      }, 0);
      return qty > 0;
    },
    calTicketQty: function() {
      let qty = this.cartTickets.reduce((accumulator, product) => {
        return accumulator + Number(product.qty);
      }, 0);
      return qty;
    },
    updateCategoryProductQty: function() {
      this.categories.forEach((category) => {
        category.products.forEach((product) => {
          product.qty = 0;
          this.cartProducts.forEach((cartProduct) => {
            if (product.productId == cartProduct.productId) {
              product.qty = cartProduct.qty;
              product.class =
                cartProduct.qty == 0 ? "clearfix" : "clearfix the_selected";
            }
          });
        });
      });
    },
    inserIntoCart() {
      // sort addons
      function sortById(a, b) {
        if(a.priority || b.priority) {
          return a.priority - b.priority
        }
        return a.id - b.id;
      }
      function checkSeletedProductQty(qty) {
        return qty && qty > 0;
      }
      function mergeCartProduct(that, _product, _selectedProductId, _cartOptions, qty, stringifyCartOptions) {
        if (that.cartProducts.length > 0) {
          let _cartProduct = that.cartProducts.find((product) => {
            return (
              product.productId == _selectedProductId &&
              JSON.stringify(product.addons) == stringifyCartOptions
            );
          });
          var _stringifyCartProductAddons = "";
          if (_cartProduct && _cartProduct.addons) {
            _stringifyCartProductAddons = JSON.stringify(_cartProduct.addons);
          }

          if (stringifyCartOptions === _stringifyCartProductAddons) {
            _cartProduct.qty = Number(_cartProduct.qty) + qty;
            _product.qty = that.calSameProductQty(_selectedProductId);
          } else {
            that.cartProducts.push({
              productId: _selectedProductId,
              isDailyNumber: _product.isDailyNumber,
              isStock: _product.isStock,
              isVisibled: _product.isVisibled,
              numOfRemain: _product.numOfRemain,
              numOfProduct: _product.numOfProduct,
              productName: _product.productName,
              productImage: _product.productImage,
              productDescription: _product.productDescription,
              productAmount: _product.productAmount,
              calorie: _product.calorie,
              addons: _cartOptions,
              addonAmt: that.addonsCalAmt(_cartOptions),
              addonStr: that.addonsToString(_cartOptions),
              addonCalorie: that.addonsCalCalorie(_cartOptions),
              qty: qty
            });

            _product.qty = that.calSameProductQty(_selectedProductId);
          }
        } else {
          that.cartProducts.push({
            productId: _selectedProductId,
            isDailyNumber: _product.isDailyNumber,
            isStock: _product.isStock,
            isVisibled: _product.isVisibled,
            numOfRemain: _product.numOfRemain,
            numOfProduct: _product.numOfProduct,
            productName: _product.productName,
            productImage: _product.productImage,
            productDescription: _product.productDescription,
            productAmount: _product.productAmount,
            calorie: _product.calorie,
            addons: _cartOptions,
            addonAmt: that.addonsCalAmt(_cartOptions),
            addonStr: that.addonsToString(_cartOptions),
            addonCalorie: that.addonsCalCalorie(_cartOptions),
            qty: qty
          });
          _product.qty = qty;
        }
      }

      if (checkSeletedProductQty(this.selectedProductQty)) {
        this.isLoaded = false;

        let _selectedProductId = this.selectedProductId;
        let _cartOptions = this.cartOptions;

        // Find product from categories
        var _product = {};
        this.categories.find((category) => {
          _product = category.products.find(
            (product) => product.productId == _selectedProductId
          );
          if (_product) return true;
          else return false;
        });

        // 1st layer title
        _cartOptions.sort(sortById);
        _cartOptions.forEach((option) => {
          if (option.selectedValues && option.selectedValues.length > 0) {
            // 1st layer value
            option.selectedValues.sort(sortById);

            option.selectedValues.forEach((selectedValue) => {
              if (
                selectedValue.subOptions &&
                selectedValue.subOptions.length > 0
              ) {
                // 2nd layer title
                selectedValue.subOptions.sort(sortById);

                selectedValue.subOptions.forEach((subOption) => {
                  // 2nd layer
                  subOption.selectedValues.sort(sortById);
                });
              }
            });
          }
        });
        let stringifyCartOptions = JSON.stringify(_cartOptions);

        let qty = Number(this.selectedProductQty);
        // merge cartProduct
        let that = this;
        mergeCartProduct(that, _product, _selectedProductId, _cartOptions, qty, stringifyCartOptions)

        let config = {
          method: "post",
          url: `${this.d.apiDomain}/session/cart`,
          data: {
            cartData: this.cartProducts,
            accountId: this.d.accountId
          }
        };
        axios(config)
          .then(() => {
            this.selectedProductQty = 1;
            this.isLoaded = true;
            this.$refs.contiShopping.click();
          })
          .catch((err) => {
            console.log("err: ", err.stack);
            this.isLoaded = true;

            swal.fire("商品數量過多，請分批下單。").then(() => {
              this.cartProducts.pop();
            });
          });
      } else {
        swal.fire("請輸入商品數量");
      }
    },
    calSameProductQty(productId) {
      let products = this.cartProducts.filter((product) => {
        return product.productId == productId;
      });
      return products.reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue.qty);
      }, 0);
    },
    calSameTicketProductQty(productId) {
      let products = this.cartTickets.filter((product) => {
        return product.productId == productId;
      });
      return products.reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue.qty);
      }, 0);
    },
    showResult() {
      // let DATA = "{\"ops\":[{\"attributes\":{\"bold\":true},\"insert\":\"ABC\"},{\"attributes\":{\"size\":\"huge\"},\"insert\":\"laksdjflsa\"},{\"insert\":\"\\n\"}]}"
      let DATA = this.businessPubInfo.content;
      try {
        var ql = new Quill(this.$refs["result"], {
          readOnly: true
        });
        ql.setContents(JSON.parse(DATA).ops);
      } catch (err) {
        console.log(err);
        this.$refs["result"].innerHTML = DATA;
      }
    },
    clickMenuHint() {
      let config = {
        method: "post",
        url: `${this.d.apiDomain}/system/menu-hint`,
        data: {
          userId: this.userId
        }
      };
      this.isLoaded = false;
      axios(config)
        .then((res) => {
          console.log(res);
          $(function() {
            $(".changeMenu_demo").fadeOut();
          });
          this.isLoaded = true;
          this.isReadTutorial = true;
        })
        .catch((err) => {
          $(".changeMenu_demo").fadeOut();
          console.log("err: ", err);
        });
    },
    openMenuAll() {
      $(function() {
        $(".menu_all").fadeIn(100);
      });
    },
    closeMenuAll() {
      $(function() {
        $(".menu_all").fadeOut(100);
      });
    },
    agreePolicy() {
      $(function() {
        $("#privacy_term").toggle();
      });
    },
    testLogin() {
      alert("prepare to login");
    },
    adjustSelectedTicketQty: function(type) {
      if (type == "plus") {
        this.selectedTicketQty++;
      } else if (type == "minus") {
        this.selectedTicketQty--;
      }
    },
    chooseTicketConfirm: function() {
      // insert into ticket cart
      this.inserIntoTicketCart();
    },
    inserIntoTicketCart() {
      // sort addons
      function sortById(a, b) {
        return a.id - b.id;
      }
      function checkSeletedProductQty(qty) {
        return qty && qty > 0;
      }
      function mergeCartProduct(that, ticket, _selectedProductId, _cartOptions, qty, stringifyCartOptions) {
        console.log(ticket, _selectedProductId, _cartOptions, qty, stringifyCartOptions)
        if (that.cartTickets.length > 0) {
          let _cartProduct = that.cartTickets.find((product) => {
            return (
              product.productId == _selectedProductId &&
              JSON.stringify(product.addons) == stringifyCartOptions
            );
          });
          var _stringifyCartProductAddons = "";
          if (_cartProduct && _cartProduct.addons) {
            _stringifyCartProductAddons = JSON.stringify(_cartProduct.addons);
          }

          if (stringifyCartOptions === _stringifyCartProductAddons) {
            _cartProduct.qty = Number(_cartProduct.qty) + qty;
            ticket.qty = that.calSameTicketProductQty(_selectedProductId);
          } else {
            that.cartTickets.push({
              productId: ticket.productId,
              isDailyNumber: ticket.isDailyNumber,
              isStock: ticket.isStock,
              isVisibled: ticket.isVisibled,
              numOfRemain: ticket.numOfRemain,
              numOfProduct: ticket.numOfProduct,
              productName: ticket.productName,
              productImage: ticket.productImage,
              productDescription: ticket.productDescription,
              productAmount: ticket.productAmount,
              calorie: ticket.calorie,
              qty: qty,
              ticketOrderNo: ticket.ticket.orderNo,
              addons: _cartOptions,
              addonAmt: that.addonsCalAmt(_cartOptions),
              addonStr: that.addonsToString(_cartOptions),
              addonCalorie: that.addonsCalCalorie(_cartOptions),
            });
            ticket.qty = that.calSameProductQty(_selectedProductId);
          }
        } else {
          that.cartTickets.push({
            productId: ticket.productId,
            isDailyNumber: ticket.isDailyNumber,
            isStock: ticket.isStock,
            isVisibled: ticket.isVisibled,
            numOfRemain: ticket.numOfRemain,
            numOfProduct: ticket.numOfProduct,
            productName: ticket.productName,
            productImage: ticket.productImage,
            productDescription: ticket.productDescription,
            productAmount: ticket.productAmount,
            calorie: ticket.calorie,
            qty: qty,
            ticketOrderNo: ticket.ticket.orderNo,
            addons: _cartOptions,
            addonAmt: that.addonsCalAmt(_cartOptions),
            addonStr: that.addonsToString(_cartOptions),
            addonCalorie: that.addonsCalCalorie(_cartOptions),
          });
          ticket.qty = qty;
        }
      }

      let ticket = this.selectedTicket;
      let qty = Number(this.selectedTicketQty);

      if (checkSeletedProductQty(qty)) {
        this.isLoaded = false;

        let _selectedProductId = ticket.productId;
        let _cartOptions = this.ticketCartOptions;

        // 1st layer title
        _cartOptions.sort(sortById);
        _cartOptions.forEach((option) => {
          if (option.selectedValues && option.selectedValues.length > 0) {
            // 1st layer value
            option.selectedValues.sort(sortById);

            option.selectedValues.forEach((selectedValue) => {
              if (
                selectedValue.subOptions &&
                selectedValue.subOptions.length > 0
              ) {
                // 2nd layer title
                selectedValue.subOptions.sort(sortById);

                selectedValue.subOptions.forEach((subOption) => {
                  // 2nd layer
                  subOption.selectedValues.sort(sortById);
                });
              }
            });
          }
        });
        let stringifyCartOptions = JSON.stringify(_cartOptions);

        let that = this;
        mergeCartProduct(that, ticket, _selectedProductId, _cartOptions, qty, stringifyCartOptions)

        let config = {
          method: "post",
          url: `${this.d.apiDomain}/session/ticket/cart`,
          data: {
            cartTicketData: this.cartTickets,
            accountId: this.d.accountId
          }
        };
        axios(config)
          .then(() => {
            this.selectedTicketQty = 1;
            this.isLoaded = true;
            this.$refs.contiShopping.click();
          })
          .catch((err) => {
            console.log("err: ", err.stack);
            this.isLoaded = true;

            swal.fire("商品數量過多，請分批下單。").then((res) => {
              console.log(res);
              this.cartTickets.pop();
            });
          });
      } else {
        swal.fire("請輸入商品數量");
      }
    },
    displayTicketList(pickUpTicket) {
      // 寄杯 list 顯示數量
      // 寄杯憑證可能有多個，但qc商品id相同，導致數量不對
      // 這個數字先不要顯示
      let cTickets = this.cartTickets;
      let qty = 0;
        cTickets.forEach(ct => {
          if(pickUpTicket.productId == ct.productId) {
            qty = ct.qty;
          }
        });
      return {
        qty
      };
    },
    cartTicketMinus: function(cartTicket, index) {
      this.disableButton(); // disableButton
      cartTicket.qty--;
      // remove zero number product
      if (cartTicket.qty <= 0) {
        this.cartTickets.splice(index, 1);
      }
      let config = {
        method: "post",
        url: `${this.d.apiDomain}/session/ticket/cart`,
        data: {
          cartTicketData: this.cartTickets,
          accountId: this.d.accountId
        }
      };
      axios(config)
        .then(() => {
          this.enableButton();
        })
        .catch((err) => {
          console.log("err: ", err.stack);
        });
    },
    cartTicketPlus: function(cartTicket) {
      this.disableButton(); // disableButton
      cartTicket.qty++;
      let config = {
        method: "post",
        url: `${this.d.apiDomain}/session/ticket/cart`,
        data: {
          cartTicketData: this.cartTickets,
          accountId: this.d.accountId
        }
      };
      axios(config)
        .then(() => {
          this.enableButton();
        })
        .catch((err) => {
          console.log("err: ", err.stack);
        });
    },
    cartTicketNumChange: function(cartTicket, index) {
      cartTicket.qty = Number(cartTicket.qty);
      // isInteger
      if (Number.isInteger(cartTicket.qty)) {
        if (cartTicket.qty >= 300) {
          cartTicket.qty = 300;
        }
        this.disableButton(); // disableButton

        // remove zero number product
        if (cartTicket.qty <= 0) {
          this.cartTickets.splice(index, 1);
        }
        let config = {
          method: "post",
          url: `${this.d.apiDomain}/session/ticket/cart`,
          data: {
            cartTicketData: this.cartTickets,
            accountId: this.d.accountId
          }
        };
        axios(config)
          .then(() => {
            this.enableButton();
          })
          .catch((err) => {
            console.log("err: ", err.stack);
          });
      } else {
        // floor
        cartTicket.qty = Math.floor(cartTicket.qty);
        swal.fire("請輸入整數");
        return;
      }
    }
  },
  watch: {
    searchStr: function() {
      this.everSwitch = false;
      this.searchInCategory();
    },
    selectedCategoryId: function(val) {
      if (val == "ever") {
        this.everSwitch = true;
        this.pickUpLaterSwitch = false;
        this.selectedCategoryName = "再點一次";
        // call ever order api
        this.isLoaded = false;
        let config = {
          url: `${this.d.apiDomain}/api/rebuild/orders`,
          method: `POST`,
          data: {
            userId: this.userId,
            accountId: this.d.accountId
          }
        };
        axios(config)
          .then((res) => {
            this.isLoaded = true;
            this.everOrders = res.data.orders;
          })
          .catch((err) => {
            this.isLoaded = true;
            console.log("err: ", err);
          });

        this.products = [];
      } else if (val == "pick-up-later") {
        this.everSwitch = false;
        this.pickUpLaterSwitch = true;
        this.selectedCategoryName = "寄杯憑證";
      } else {
        this.categories.forEach((category) => {
          if (category.categoryId == val) {
            this.pickUpLaterSwitch = false;
            this.everSwitch = false;
            this.products = category.products;
            this.products.forEach((p) => (p.isShow = 1));
            this.selectedCategoryName = category.categoryName;
          }
        });
      }
    },
    selectedProductQty: function(val, old) {
      let v = Number(val);
      if (Number.isInteger(v)) {
        if (v >= 300) {
          this.selectedProductQty = 300;
        }
      } else {
        this.selectedProductQty = Number(old);
      }
    },
    "cartProduct.qty": function(val) {
      if (val >= 300) {
        this.cartProduct.qty = 300;
      }
    },
    "groupbuy.isGroupbuy": function(val) {
      let liffId = this.d.liffId;
      if (val) {
        this.toPay = `${this.d.apiDomain}/views/groupbuy/${this.groupbuy.id}/confirm?accountId=${this.d.accountId}&userId=${this.userId}&liffId=${liffId}&source=${this.d.source}&token=${this.d.token}&gt=${this.gt}`;
      } else {
        this.toPay = `${this.d.apiDomain}/views/liff/liff2-order-flow?accountId=${this.d.accountId}&userId=${this.userId}&liffId=${liffId}&source=${this.d.source}&token=${this.d.token}&gt=<%= gt %>`;
      }
    },
    "groupbuy.shareableUrl": function(val) {
      this.lineShareUrl = `https://line.me/R/msg/text/?跟我一起點 ${val}`;
    },
    selectedTicketQty: function(val, old) {
      let v = Number(val);
      if (Number.isInteger(v)) {
        if (v >= 300) {
          this.selectedTicketQty = 300;
        }
        if (v <= 0) {
          this.selectedTicketQty = 1;
        }
      } else {
        this.selectedTicketQty = Number(old);
      }
    }
  }
};
</script>

<style>
@import "./assets/standard.css";
</style>
<style>
@import "./assets/jquery.modal.min.0.9.1.css";
</style>
<style>
@import "./assets/fontawesome/css/all.min.css";
</style>
<style scoped>
  .multi_checkbox_checked {
    color: #FFF !important;
    border-color: #f0941d !important;
    background-color: #f0941d !important;
  }
  .multi_checkbox {
    display: block !important;
    padding: 5px 15px !important;
    font-size: 14px !important;
    border: 2px solid #E5E6E5 !important;
    -webkit-border-radius: 25px !important;
    cursor: pointer !important;
    color: #000 !important;
    background-color: #FFF !important;
  }
  .display {
    display: block !important;
  }
  .option_list li {
			margin: 4px 10px 6px 0;
		}
</style>